export default {
    2371: {
        desc: 'All systems OK.',
        longDesc: ''
    },
    2372: {
        desc: 'Maintain safe distance: \nActive Cruise Control.',
        longDesc:
            "Active Cruise Control: \nActive Cruise Control deactivated. \nMaintain safe distance. \nSystem deactivation due to current driving situation. Reactivate Active Cruise Control if desired when the driving situation allows. \nSee Owner's Manual for system description."
    },
    2373: {
        desc: 'Active Cruise Control.',
        longDesc:
            "Active Cruise Control: \nActive Cruise Control deactivated. \nMaintain safe distance. Sensor dirty. Please clean sensor, see Owner's Manual."
    },
    2374: {
        desc: 'Active Cruise Control.',
        longDesc: 'Active Cruise Control malfunction: \nMaintain safe distance. Consult service center.'
    },
    2375: {
        desc: 'Trailer: Tail lamp \nmalfunction.',
        longDesc: ''
    },
    2376: {
        desc: 'Trailer: Tail lamp \nmalfunction.',
        longDesc: ''
    },
    2377: {
        desc: 'Trailer: Turn \nsignal malfunction.',
        longDesc: ''
    },
    2378: {
        desc: 'Trailer: Turn \nsignal malfunction.',
        longDesc: ''
    },
    2379: {
        desc: 'Trailer: Brake \nlamp malfunction.',
        longDesc: ''
    },
    2380: {
        desc: 'Trailer: Fog lamp \nmalfunction.',
        longDesc: ''
    },
    2381: {
        desc: 'Continued driving \npossible: Chassis.',
        longDesc: 'Chassis function restricted: \nDrive moderately. \nConsult service center.'
    },
    2382: {
        desc: '',
        longDesc: ''
    },
    2383: {
        desc: 'Cornering behavior \nreduced.',
        longDesc: ''
    },
    2384: {
        desc: '',
        longDesc: ''
    },
    2385: {
        desc: 'Door open.',
        longDesc: ''
    },
    2386: {
        desc: 'Door open.',
        longDesc: ''
    },
    2387: {
        desc: 'Door open.',
        longDesc: ''
    },
    2388: {
        desc: 'Door open.',
        longDesc: ''
    },
    2389: {
        desc: 'Hood open.',
        longDesc: ''
    },
    2390: {
        desc: 'Trunk open.',
        longDesc: ''
    },
    2391: {
        desc: '',
        longDesc: ''
    },
    2392: {
        desc: 'Engine start \nnot possible.',
        longDesc: ''
    },
    2393: {
        desc: 'Do not stop engine: \nStarter.',
        longDesc: ''
    },
    2394: {
        desc: '',
        longDesc: ''
    },
    2395: {
        desc: 'Cont. driving possible: \nBrake system.',
        longDesc: ''
    },
    2396: {
        desc: 'Preheating: \nPlease wait.',
        longDesc: ''
    },
    2398: {
        desc: 'Oil at minimum. \nPlease refill.',
        longDesc: "Engine oil at minimum level: \nAdd 1 quart of oil as soon as possible, see Owner's Manual."
    },
    2399: {
        desc: 'Oil below minimum. \nRefill immediately.',
        longDesc:
            "Engine oil level below minimum: \nContinued driving may cause engine damage. Add 1 quart of oil immediately. See Owner's Manual."
    },
    2400: {
        desc: 'Cont. driving possible: \nDrivetrain.',
        longDesc: 'Drivetrain malfunction: \nDrive moderately. Maximum drivetrain output not available. Consult service center.'
    },
    2401: {
        desc: '',
        longDesc: ''
    },
    2402: {
        desc: '',
        longDesc: ''
    },
    2403: {
        desc: 'Please tighten \nfuel cap.',
        longDesc: 'Fuel cap open: \nPlease check if the fuel cap is fully tightened. Fuel or vapors may escape.'
    },
    2404: {
        desc: '',
        longDesc: ''
    },
    2405: {
        desc: 'Emission warning light  (MIL)',
        longDesc: ''
    },
    2406: {
        desc: 'Cont. driving possible: \nChassis stabilization.',
        longDesc: ''
    },
    2407: {
        desc: 'DSC inactive.',
        longDesc: ''
    },
    2408: {
        desc: 'Trigger %0',
        longDesc: ''
    },
    2409: {
        desc: 'Remote control: \nIncorrect key.',
        longDesc: 'Remote control: \nIncorrect key, please check the key. The key used does not match the vehicle.'
    },
    2410: {
        desc: 'Stop carefully: \nEngine overheated.',
        longDesc: ''
    },
    2411: {
        desc: 'To start engine: \nPress brake pedal.',
        longDesc: ''
    },
    2412: {
        desc: 'Service due.',
        longDesc: 'Service due: \nYour service center could not be automatically updated. Contact service center.'
    },
    2413: {
        desc: 'Cont. driving possible: \nBrake system.',
        longDesc: ''
    },
    2414: {
        desc: 'EDC malfunction.',
        longDesc: ''
    },
    2416: {
        desc: 'Level control \nmalfunction.',
        longDesc: ''
    },
    2417: {
        desc: '',
        longDesc: ''
    },
    2418: {
        desc: '',
        longDesc: ''
    },
    2419: {
        desc: '',
        longDesc: ''
    },
    2420: {
        desc: 'Cont. driving possible: \nDrivetrain.',
        longDesc: 'Drivetrain: \nContinued driving possible. \nConsult service center.'
    },
    2421: {
        desc: 'Cont. driving possible: \nFlat Tire Monitor (FTM).',
        longDesc: ''
    },
    2422: {
        desc: '',
        longDesc: ''
    },
    2423: {
        desc: 'Secure vehicle \nagainst rolling',
        longDesc: 'Parking brake: \nParking brake has overheated due to frequent use. Secure vehicle against rolling when parked.'
    },
    2424: {
        desc: 'Cont. driving possible: \nAutomatic Hold.',
        longDesc: 'Automatic Hold: \nManually apply brakes. Engage and release parking brake if necessary. Consult service center.'
    },
    2425: {
        desc: 'Cont. driving possible: \nParking brake.',
        longDesc:
            'Parking brake reduced: \nDrive moderately. Not possible to use parking brake while driving. Engage / release while stationary. Consult service center.'
    },
    2426: {
        desc: 'Release \nparking brake.',
        longDesc: ''
    },
    2427: {
        desc: '',
        longDesc: ''
    },
    2428: {
        desc: '',
        longDesc: ''
    },
    2429: {
        desc: '',
        longDesc: ''
    },
    2430: {
        desc: '',
        longDesc: ''
    },
    2431: {
        desc: 'Instrument panel \nmalfunction.',
        longDesc: ''
    },
    2432: {
        desc: '',
        longDesc: ''
    },
    2433: {
        desc: 'Speed warning.',
        longDesc: ''
    },
    2434: {
        desc: 'Flat tire.',
        longDesc: "Tire pressure loss: \nStop carefully. See Owner's Manual for important information."
    },
    2435: {
        desc: '',
        longDesc: ''
    },
    2436: {
        desc: '',
        longDesc: ''
    },
    2437: {
        desc: 'Remote control \nis missing.',
        longDesc: "Remote control not detected: \nEngine start not possible. Remote control may be faulty. See Owner's Manual."
    },
    2438: {
        desc: 'Remote control \nbattery is empty.',
        longDesc: ''
    },
    2439: {
        desc: '',
        longDesc:
            "Remote control battery discharged: \nBatteries for stationary functions are discharged. Replace batteries. See Owner's Manual."
    },
    2440: {
        desc: 'Speed below minimum \ncontrol speed.',
        longDesc: ''
    },
    2441: {
        desc: 'Cont. driving possible: \nIncreased steer. effort.',
        longDesc: 'Steering: \nDrive moderately. \nIncreased steering effort required. \nConsult service center.'
    },
    2442: {
        desc: 'Cont. driving possible: \nBrake pads.',
        longDesc: 'Brake system: \nDrive moderately. Replace brake pads. Consult service center.'
    },
    2443: {
        desc: '',
        longDesc: ''
    },
    2445: {
        desc: 'Stop carefully: \nBrake system.',
        longDesc: ''
    },
    2446: {
        desc: 'Do not drive with \ntrailer connected.',
        longDesc: 'Trailer electrical system: \nMalfunction. Check trailer lamps. Consult nearest service center.'
    },
    2447: {
        desc: '',
        longDesc: ''
    },
    2448: {
        desc: '',
        longDesc: ''
    },
    2449: {
        desc: 'Speed warning.',
        longDesc: ''
    },
    2450: {
        desc: 'Outside temperature: \n%0',
        longDesc: ''
    },
    2451: {
        desc: '',
        longDesc: ''
    },
    2452: {
        desc: '',
        longDesc: ''
    },
    2453: {
        desc: '',
        longDesc: ''
    },
    2454: {
        desc: '',
        longDesc: ''
    },
    2455: {
        desc: '',
        longDesc: ''
    },
    2456: {
        desc: 'Active Cruise Control \ndeactivated.',
        longDesc:
            'Active Cruise Control deactivated: \nDue to prolonged use of brakes. Maintain safe distance. Use brakes as necessary. Reactive if desired.'
    },
    2457: {
        desc: '',
        longDesc: ''
    },
    2458: {
        desc: 'Right tail lamp \nmalfunction.',
        longDesc: ''
    },
    2459: {
        desc: 'Left low beam \nmalfunction.',
        longDesc: 'Left low beam lamp malfunction: \nConsult nearest service center.'
    },
    2460: {
        desc: 'Right low beam \nmalfunction.',
        longDesc: 'Right low beam lamp \nRight low beam lamp malfunction: Consult nearest service center.'
    },
    2461: {
        desc: 'Trailer: Reverse lamp \nmalfunction.',
        longDesc: ''
    },
    2462: {
        desc: 'Fasten safety belt.',
        longDesc: ''
    },
    2463: {
        desc: '',
        longDesc: ''
    },
    2464: {
        desc: '',
        longDesc: ''
    },
    2465: {
        desc: 'Restraint system: \nRear.',
        longDesc: ''
    },
    2466: {
        desc: 'Restraint system: \nRight rear.',
        longDesc: ''
    },
    2468: {
        desc: 'Restraint system.',
        longDesc: ''
    },
    2469: {
        desc: '',
        longDesc: ''
    },
    2470: {
        desc: '',
        longDesc: ''
    },
    2471: {
        desc: '',
        longDesc: ''
    },
    2472: {
        desc: '',
        longDesc: ''
    },
    2473: {
        desc: '',
        longDesc: ''
    },
    2474: {
        desc: 'Cont. driving possible: \nTransmission temp.',
        longDesc: 'Transmission temperature warning. \nContinued driving is possible. Reduced engine power.'
    },
    2475: {
        desc: 'Stop carefully: \nTransmission temp.',
        longDesc:
            'Transmission overheated. \nStop carefully and shift into Park. \nTo cool the transmission quicker, let engine idle. You can continue driving once this message has disappeared.'
    },
    2476: {
        desc: 'Clutch: \nStop carefully.',
        longDesc:
            'Clutch temperature: \nStop carefully and shift into Park. Keep engine running to allow clutch to cool faster. You can continue driving once this message has disappeared.'
    },
    2477: {
        desc: '',
        longDesc: ''
    },
    2478: {
        desc: '',
        longDesc: ''
    },
    2479: {
        desc: 'Driver restraint \nsystem.',
        longDesc: ''
    },
    2480: {
        desc: 'Passenger restraint \nsystem.',
        longDesc: ''
    },
    2481: {
        desc: '',
        longDesc: ''
    },
    2482: {
        desc: '',
        longDesc: ''
    },
    2483: {
        desc: '',
        longDesc: ''
    },
    2484: {
        desc: 'Parking lights on.',
        longDesc: ''
    },
    2485: {
        desc: 'Rear fog lamp \nmalfunction.',
        longDesc: 'Rear fog lamp malfunction: \nConsult nearest service center.'
    },
    2486: {
        desc: 'Reverse lamp \nmalfunction.',
        longDesc: 'Reverse lamp malfunction: \nConsult nearest service center.'
    },
    2487: {
        desc: 'Left rear turn \nsignal malfunction.',
        longDesc: 'Left rear turn signal malfunction: \nConsult nearest service center.'
    },
    2488: {
        desc: 'Reverse lamp \nmalfunction.',
        longDesc: 'Reverse lamp malfunction: \nConsult nearest service center.'
    },
    2489: {
        desc: 'Right tail lamp \nmalfunction.',
        longDesc: 'Right tail lamp malfunction: \nConsult nearest service center.'
    },
    2490: {
        desc: 'Right front turn \nsignal malfunction.',
        longDesc: 'Right front turn signal malfunction: \nConsult nearest service center.'
    },
    2491: {
        desc: 'Left low beam \nmalfunction.',
        longDesc: 'Left low beam lamp malfunction: \nConsult nearest service center.'
    },
    2492: {
        desc: 'Right low beam \nmalfunction.',
        longDesc: 'Right low beam lamp malfunction: \nConsult nearest service center.'
    },
    2493: {
        desc: 'Left front turn \nsignal malfunction.',
        longDesc: 'Left front turn signal malfunction: \nConsult nearest service center.'
    },
    2494: {
        desc: 'Left tail lamp \nmalfunction.',
        longDesc: ''
    },
    2495: {
        desc: '',
        longDesc: ''
    },
    2496: {
        desc: 'Right rear turn \nsignal malfunction.',
        longDesc: 'Right rear turn signal malfunction: \nConsult nearest service center.'
    },
    2497: {
        desc: 'Fog lamp \nmalfunction.',
        longDesc: 'Fog lamp malfunction: \nConsult service center.'
    },
    2498: {
        desc: '',
        longDesc: ''
    },
    2499: {
        desc: 'Left high beam \nmalfunction.',
        longDesc: 'Left high beam malfunction: \nConsult service center.'
    },
    2500: {
        desc: 'Rear fog lamp \nmalfunction.',
        longDesc: 'Rear fog lamp malfunction: \nConsult service center.'
    },
    2501: {
        desc: 'Right high beam \nmalfunction.',
        longDesc: 'Right high beam malfunction: \nConsult service center.'
    },
    2502: {
        desc: 'Front parking \nlight malfunction.',
        longDesc: 'Parking lamp malfunction: \nConsult service center.'
    },
    2503: {
        desc: 'Front parking \nlight malfunction.',
        longDesc: 'Parking lamp malfunction: \nConsult service center.'
    },
    2504: {
        desc: 'Left tail lamp \nmalfunction.',
        longDesc: 'Left tail lamp malfunction: \nConsult nearest service center.'
    },
    2505: {
        desc: 'Right brake lamp \nmalfunction.',
        longDesc: 'Right brake lamp malfunction: \nConsult nearest service center.'
    },
    2506: {
        desc: '',
        longDesc: ''
    },
    2507: {
        desc: 'Left brake lamp \nmalfunction.',
        longDesc: 'Left brake lamp malfunction: \nConsult nearest service center.'
    },
    2508: {
        desc: '',
        longDesc: ''
    },
    2509: {
        desc: 'Fog lamp \nmalfunction.',
        longDesc: 'Fog lamp malfunction: \nConsult service center.'
    },
    2510: {
        desc: 'Stop carefully: \nLow tire.',
        longDesc:
            'Left front tire low: \nStop carefully and check tires. On cars with run-flat tires ("RSC" symbol), the journey can be continued at speeds of up to 50 mph. See Owner\'s Manual.'
    },
    2511: {
        desc: 'Stop carefully: \nLow tire.',
        longDesc:
            'Right rear tire low: \nStop carefully and check tires. On cars with run-flat tires ("RSC" symbol), the journey can be continued at speeds of up to 50 mph. See Owner\'s Manual.'
    },
    2512: {
        desc: 'Stop carefully: \nLow tire.',
        longDesc:
            'Left rear tire low: \nStop carefully and check tires. On cars with run-flat tires ("RSC" symbol), the journey can be continued at speeds of up to 50 mph. See Owner\'s Manual.'
    },
    2513: {
        desc: 'Tire change recognized.',
        longDesc:
            "Check tire pressure: \nCheck tire pressure and correct if necessary. \nAfterwards, perform Tire Pressure Monitor reset (TPM). \nSee Owner's Manual for further information."
    },
    2514: {
        desc: 'Stop carefully: \nLow tire.',
        longDesc:
            'Right front tire low: \nStop carefully and check tires. On cars with run-flat tires ("RSC" symbol), the journey can be continued at speeds of up to 50 mph. See Owner\'s Manual.'
    },
    2515: {
        desc: 'Tire Pressure Monitor \ntemporarily inactive.',
        longDesc:
            'TPM temporarily inactive: \nTire Pressure Monitor temporarily inactive due to external interference (e.g. TV/radio transmitters, wireless headphones). \nUnable to detect tire pressure loss. Drive moderately.'
    },
    2516: {
        desc: 'TPM malfunction',
        longDesc: ''
    },
    2518: {
        desc: 'Stop carefully: \nLow tire.',
        longDesc:
            'Low tire: \nStop carefully and check tires. On cars with run-flat tires ("RSC" symbol), the journey can be continued at speeds of up to 50 mph. See Owner\'s Manual.'
    },
    2519: {
        desc: 'Brake lamp control \nmalfunction.',
        longDesc: 'Brake lamp control malfunction: \nConsult nearest service center.'
    },
    2520: {
        desc: 'TPM malfunction.',
        longDesc: ''
    },
    2521: {
        desc: 'Armored luggage \ncompart. door open.',
        longDesc: ''
    },
    2522: {
        desc: 'Hazardous gas: \nAir supply activated.',
        longDesc: ''
    },
    2523: {
        desc: 'Disconnect \ncharging cable.',
        longDesc: ''
    },
    2524: {
        desc: 'Gun mount \nmalfunction.',
        longDesc: ''
    },
    2525: {
        desc: 'Irritant gas \nsensor malfunction.',
        longDesc: ''
    },
    2527: {
        desc: 'Air system \nnot functioning.',
        longDesc: ''
    },
    2528: {
        desc: 'Air system active.',
        longDesc: ''
    },
    2529: {
        desc: '',
        longDesc: ''
    },
    2530: {
        desc: 'Doors not locked.',
        longDesc: ''
    },
    2531: {
        desc: 'Use power window \nemergency function.',
        longDesc: ''
    },
    2532: {
        desc: 'Second battery \nmalfunction.',
        longDesc: ''
    },
    2533: {
        desc: 'Flashing beacon: \nCheck lamp.',
        longDesc: ''
    },
    2534: {
        desc: 'Fire extinguishing \nsystem activated.',
        longDesc: ''
    },
    2535: {
        desc: 'Washer fluid \nlevel low.',
        longDesc: "Washer fluid level low: \nInsufficient fluid level in reservoir. Refill as soon as possible. See Owner's Manual."
    },
    2536: {
        desc: 'Outside temperature \n%0',
        longDesc: ''
    },
    2537: {
        desc: 'Refill coolant.',
        longDesc:
            "Engine coolant level low: \nTop off as soon as possible, see Owner's Manual. Possible engine damage. Attention: Scalding hazard."
    },
    2538: {
        desc: 'Set time and date.',
        longDesc: "Set time and date: \nTo reset the time and date display, see Owner's Manual."
    },
    2539: {
        desc: '',
        longDesc: ''
    },
    2540: {
        desc: '',
        longDesc: ''
    },
    2541: {
        desc: 'Call Roadside Assist.: \nDrivetrain malfunction.',
        longDesc: ''
    },
    2542: {
        desc: '',
        longDesc: ''
    },
    2543: {
        desc: '',
        longDesc: ''
    },
    2544: {
        desc: 'Continued driving \npossible: Transmission.',
        longDesc: ''
    },
    2545: {
        desc: 'Transmission in Park \nonly when stopped.',
        longDesc: ''
    },
    2546: {
        desc: 'Secure vehicle \nagainst rolling.',
        longDesc: 'Transmission: \nSecure vehicle with parking brake when stopped. Consult service center.'
    },
    2547: {
        desc: '',
        longDesc: ''
    },
    2548: {
        desc: '',
        longDesc: ''
    },
    2549: {
        desc: '',
        longDesc: ''
    },
    2550: {
        desc: 'Drivetrain malfunction.',
        longDesc:
            'Transmission malfunction: \nDrive moderately. Set parking brake when stopped. Possible to engage gear without depressing brake pedal. Engine start may be delayed. Consult service center.'
    },
    2551: {
        desc: 'Driving comfort \nreduced.',
        longDesc: ''
    },
    2552: {
        desc: '',
        longDesc: ''
    },
    2553: {
        desc: '',
        longDesc: ''
    },
    2554: {
        desc: 'Windshield wiper \nmalfunction.',
        longDesc: 'Windshield wiper: \nPossible malfunction soon. Consult service center.'
    },
    2555: {
        desc: 'Dynamic Traction \nControl activated.',
        longDesc: ''
    },
    2556: {
        desc: '',
        longDesc: ''
    },
    2557: {
        desc: 'Stop carefully. Steer. \nwheel lock malf.',
        longDesc: ''
    },
    2558: {
        desc: 'Press start and \nturn steering wheel.',
        longDesc: 'Steering wheel locked: \nTo start the engine, simultaneously press Start/Stop button and turn steering wheel.'
    },
    2561: {
        desc: '',
        longDesc: ''
    },
    2562: {
        desc: '',
        longDesc: ''
    },
    2563: {
        desc: 'Resetting Tire \nPressure Monitor…',
        longDesc:
            'Tire Pressure Monitor (TPM) reset: \nLoss of tire pressure during the reset process cannot be detected. \nPlease note: The current tire pressures will be measured and registered while driving.'
    },
    2564: {
        desc: 'Emergency exit \nmalfunction.',
        longDesc: ''
    },
    2565: {
        desc: 'Window open.',
        longDesc: ''
    },
    2566: {
        desc: 'Parking assistance.',
        longDesc: 'Parking assistance: \nNo parking assistance, please park unaided. Consult service center.'
    },
    2567: {
        desc: '',
        longDesc: ''
    },
    2568: {
        desc: '',
        longDesc: ''
    },
    2570: {
        desc: '',
        longDesc: ''
    },
    2571: {
        desc: '',
        longDesc: ''
    },
    2572: {
        desc: 'Apply the brakes: \nAutomatic Hold.',
        longDesc: 'Automatic Hold: \nApply the brakes. Automatic Hold deactivated due to slippery road surface.'
    },
    2573: {
        desc: '',
        longDesc: ''
    },
    2574: {
        desc: 'Transmission in \nNeutral.',
        longDesc: ''
    },
    2575: {
        desc: 'Driving comfort \ntemporarily reduced.',
        longDesc: 'Chassis function restricted: \nDrive moderately. Dynamic Drive is temporarily not available.'
    },
    2576: {
        desc: '',
        longDesc: ''
    },
    2577: {
        desc: 'Next press of button \nstarts engine.',
        longDesc:
            'Start/Stop button: \nEngine will start with the next press of the button, possibly without depressing the clutch or brake pedal.'
    },
    2578: {
        desc: '',
        longDesc: ''
    },
    2579: {
        desc: 'Comfort access \nlimited.',
        longDesc: ''
    },
    2580: {
        desc: 'Remote control: \nInside vehicle.',
        longDesc:
            'Remote control is inside vehicle: \nIt is not possible to lock the vehicle. \nRemove remote control from inside the vehicle.'
    },
    2581: {
        desc: '',
        longDesc: ''
    },
    2582: {
        desc: '',
        longDesc: ''
    },
    2583: {
        desc: 'Stop carefully: \nEngine oil pressure.',
        longDesc: ''
    },
    2584: {
        desc: 'Stop carefully: \nPower supply.',
        longDesc: ''
    },
    2586: {
        desc: '',
        longDesc: ''
    },
    2587: {
        desc: 'Cont. driving possible: \nFuel system.',
        longDesc: 'Fuel supply \nFull drive performance not available. \nDrive moderately. Consult service center.'
    },
    2588: {
        desc: 'Hold remote control \nto steering column.',
        longDesc: "Remote control: \nHold remote control to marking on steering column. See Owner's Manual for additional information."
    },
    2590: {
        desc: '',
        longDesc: ''
    },
    2591: {
        desc: '',
        longDesc: ''
    },
    2592: {
        desc: 'Hazardous gas: \nVacate area.',
        longDesc: ''
    },
    2593: {
        desc: '',
        longDesc: ''
    },
    2594: {
        desc: 'Electrical system \nmalfunction.',
        longDesc: ''
    },
    2595: {
        desc: 'Starter \nmalfunction.',
        longDesc: ''
    },
    2596: {
        desc: 'Windshield \nunlocked.',
        longDesc: ''
    },
    2597: {
        desc: 'Fire extinguishing \nsystem malfunction.',
        longDesc: ''
    },
    2598: {
        desc: '',
        longDesc: ''
    },
    2599: {
        desc: '',
        longDesc: ''
    },
    2600: {
        desc: 'Start engine: Battery \nsubstantially discharg.',
        longDesc:
            'Vehicle battery charge low: \nCharge by driving for longer periods or use external charger. Functions requiring battery will be switched off.'
    },
    2601: {
        desc: '',
        longDesc: ''
    },
    2602: {
        desc: 'Stop carefully: \nLighting system.',
        longDesc:
            'Lighting system malfunction: \nStop carefully, check lights and if necessary, continue driving. Consult nearest service center.'
    },
    2603: {
        desc: 'Protection system \nmalfunction.',
        longDesc: ''
    },
    2604: {
        desc: 'Communication \nmalfunction.',
        longDesc: ''
    },
    2605: {
        desc: 'Assault alarm \nmalfunction.',
        longDesc: ''
    },
    2607: {
        desc: 'Cont. driving possible: \nChassis stabilization.',
        longDesc: ''
    },
    2608: {
        desc: '',
        longDesc: ''
    },
    2609: {
        desc: '',
        longDesc: ''
    },
    2610: {
        desc: '',
        longDesc: ''
    },
    2611: {
        desc: 'Parking brake \nmalfunction.',
        longDesc:
            "Parking brake malfunction: \nSecure vehicle from rolling away. See Owner's Manual for emergency release. Consult service center."
    },
    2612: {
        desc: '',
        longDesc: ''
    },
    2613: {
        desc: '',
        longDesc: ''
    },
    2614: {
        desc: '',
        longDesc: ''
    },
    2615: {
        desc: 'To select gear: \nPress brake.',
        longDesc: ''
    },
    2616: {
        desc: 'Driving comfort \nreduced.',
        longDesc: ''
    },
    2617: {
        desc: '',
        longDesc: ''
    },
    2618: {
        desc: '',
        longDesc: ''
    },
    2619: {
        desc: '',
        longDesc: ''
    },
    2620: {
        desc: '',
        longDesc: ''
    },
    2621: {
        desc: 'Press brake \nto engage gear.',
        longDesc:
            'Press brake to engage gear: \nPossible without brake. Turn off engine and use parking brake when leaving vehicle. Consult service center.'
    },
    2622: {
        desc: '',
        longDesc: ''
    },
    2623: {
        desc: '',
        longDesc: ''
    },
    2624: {
        desc: '',
        longDesc: ''
    },
    2625: {
        desc: '',
        longDesc: ''
    },
    2626: {
        desc: '',
        longDesc: ''
    },
    2627: {
        desc: 'Headlamp vertical aim \ncontrol malfunction.',
        longDesc:
            'Headlamp vertical aim control: \nMalfunction. Road illumination may be reduced or interfere with on-coming traffic. Consult service center.'
    },
    2628: {
        desc: 'Cont. driving possible: \nEngine temperature.',
        longDesc: ''
    },
    2629: {
        desc: '',
        longDesc: ''
    },
    2631: {
        desc: '',
        longDesc: ''
    },
    2632: {
        desc: 'Error Electric Windows or Initialization neccessary',
        longDesc: ''
    },
    2633: {
        desc: 'Automatic rain \nclosure malfunction.',
        longDesc: ''
    },
    2634: {
        desc: '',
        longDesc: ''
    },
    2636: {
        desc: 'Check \ntire pressure.',
        longDesc:
            "Check tire pressure: \nCheck tire pressure and correct if necessary. \nAfterwards, perform Tire Pressure Monitor reset (TPM). \nSee Owner's Manual for further information."
    },
    2637: {
        desc: 'Cont. driving possible: \nRoll protection.',
        longDesc: ''
    },
    2639: {
        desc: '',
        longDesc: ''
    },
    2640: {
        desc: '',
        longDesc: ''
    },
    2641: {
        desc: '',
        longDesc: ''
    },
    2642: {
        desc: 'Retractable top: \nReduce speed.',
        longDesc: 'Retractable top: \nExceeded max. allowable speed for opening / closing. Reduce speed, then continue opening / closing.'
    },
    2643: {
        desc: '',
        longDesc: ''
    },
    2644: {
        desc: 'Active steering \nmalfunction.',
        longDesc: ''
    },
    2646: {
        desc: 'Fuel reserve.',
        longDesc: ''
    },
    2648: {
        desc: 'Active Cruise Control \ndeactivated.',
        longDesc:
            'Active Cruise Control deactivated: \nSelected gear is not suitable. Change gear and reactivate Active Cruise Control if desired.'
    },
    2649: {
        desc: 'Select lower gear.',
        longDesc: 'Active Cruise Control: \nIf the driving situation permits, select a lower gear.'
    },
    2650: {
        desc: "Driver's seatback \nnot locked.",
        longDesc: "Driver's seatback: \nSeatback is not locked. Important: Engage seatback before driving."
    },
    2651: {
        desc: 'Front passenger \nseatback not locked.',
        longDesc: 'Front passenger seatback: \nSeatback not locked. Important: Engage seatback before driving.'
    },
    2652: {
        desc: 'Service due in \n%0',
        longDesc: ''
    },
    2655: {
        desc: 'Service overdue \n%0',
        longDesc: ''
    },
    2656: {
        desc: 'Service due in \n%0',
        longDesc: ''
    },
    2657: {
        desc: 'Range %0',
        longDesc: ''
    },
    2658: {
        desc: 'Clutch temperature: \nDrive moderately',
        longDesc:
            'Clutch temperature: \nContinued driving possible. Avoid frequent start-stop and long periods of driving below walking speed.'
    },
    2666: {
        desc: 'Adaptive headlight \nmalfunction.',
        longDesc: 'Adaptive headlight malfunction: \nConsult service center.'
    },
    2667: {
        desc: '',
        longDesc: ''
    },
    2668: {
        desc: '',
        longDesc: ''
    },
    2669: {
        desc: '',
        longDesc: ''
    },
    2670: {
        desc: 'Emergency call system \nmalfunction.',
        longDesc: 'Emergency call system: \nMalfunction or limited functionality. Consult service center.'
    },
    2671: {
        desc: '',
        longDesc: ''
    },
    2672: {
        desc: 'Seatback monitoring \nmalfunction.',
        longDesc: 'Seatback monitoring malfunction: \nEnsure seatback is engaged. Consult service center.'
    },
    2674: {
        desc: 'To start engine: \nDepress clutch.',
        longDesc: ''
    },
    2675: {
        desc: 'Cont. driving possible: \nReplace battery.',
        longDesc: 'Replace battery: \nContinued driving possible. Have the battery replaced as soon as possible.'
    },
    2676: {
        desc: 'Do not turn off engine: \nElectrical power supply.',
        longDesc: ''
    },
    2679: {
        desc: '',
        longDesc: ''
    },
    2680: {
        desc: 'Fuel system: Contin. \ndriving possible.',
        longDesc: 'Fuel system malfunction: \nDrive moderately. Consult service center.'
    },
    2691: {
        desc: 'Retractable top \nmovement complete.',
        longDesc: ''
    },
    2692: {
        desc: '',
        longDesc: 'Active steering temporarily inactive: \nModerate driving possible. Activation in progress.'
    },
    2695: {
        desc: '',
        longDesc: ''
    },
    2697: {
        desc: 'Secure vehicle \nagainst rolling.',
        longDesc:
            'Secure vehicle against rolling: \nSecure vehicle against rolling when parked. When driving, fasten seatbelt and close doors.'
    },
    2698: {
        desc: 'Resetting Tire \nPressure Monitor…',
        longDesc:
            'Tire Pressure Monitor (TPM) reset: \nLoss of tire pressure during the reset process cannot be detected. \nPlease note: The current tire pressures will be measured and registered while driving.'
    },
    2699: {
        desc: 'Cont. driving possible: \nBrake pad wear sensor.',
        longDesc: ''
    },
    2701: {
        desc: 'Hill Descent Control \ncurrently inactive.',
        longDesc: 'Hill Descent Control inactive: \nSelect a lower gear and drive moderately to avoid overheating the brakes.'
    },
    2702: {
        desc: 'Hill Descent Control \nactive.',
        longDesc: ''
    },
    2703: {
        desc: 'Hill Descent Control \ndeactivated.',
        longDesc:
            "Hill Descent Control deactivated: \nSystem deactivated above 35 mph. Reactivation possible under 20 mph. See Owner's Manual."
    },
    2704: {
        desc: 'Hill Descent Control \ncurrently inactive.',
        longDesc:
            'Hill Descent Control inactive: \nSystem limited to 20 mph and will automatically reactivate below 20 mph. Reduce speed accordingly.'
    },
    2706: {
        desc: 'Ignition switched on.',
        longDesc: ''
    },
    2707: {
        desc: '',
        longDesc: ''
    },
    2708: {
        desc: 'Cruise Control.',
        longDesc: 'Cruise Control malfunction: \nConsult service center.'
    },
    2710: {
        desc: 'Cruise Control \ndeactivated.',
        longDesc: 'Cruise Control deactivated: \nDeactivated due to extended downhill driving/coasting. Reactivation if desired.'
    },
    2711: {
        desc: 'Cruise Control \ndeactivated.',
        longDesc: "Cruise Control deactivated: \nReactivate if desired. See Owner's Manual."
    },
    2712: {
        desc: 'Cruise Control \ndeactivated.',
        longDesc: 'Cruise Control deactivated: \nSelected gear does not match driving situation. Change gears and reactivate if desired.'
    },
    2713: {
        desc: 'Cruise Control \ndeactivated.',
        longDesc: 'Cruise Control deactivated: \nSystem deactivated below 20 mph. Reactivate if desired.'
    },
    2716: {
        desc: 'Right brake/tail lamp \nmalfunction.',
        longDesc: 'Right brake/tail lamp malfunction: \nConsult nearest service center.'
    },
    2717: {
        desc: 'Left brake/tail \nlamp malfunction.',
        longDesc: 'Left brake/tail lamp malfunction: \nConsult nearest service center.'
    },
    2718: {
        desc: '',
        longDesc: ''
    },
    2720: {
        desc: '',
        longDesc: ''
    },
    2721: {
        desc: 'Cont. driving possible: \nFour-wheel-drive syst.',
        longDesc: ''
    },
    2722: {
        desc: '',
        longDesc: ''
    },
    2725: {
        desc: 'Vehicle may \nroll back.',
        longDesc: ''
    },
    2727: {
        desc: 'Night Vision.',
        longDesc: ''
    },
    2735: {
        desc: 'Resetting Flat Tire \nMonitor…',
        longDesc:
            'Resetting Flat Tire Monitor (FTM) \nAny loss of tire pressure cannot be detected while resetting is in progress. \nPlease note: Resetting takes place while driving.'
    },
    2738: {
        desc: 'Cont. driving possible: \nEngine temperature.',
        longDesc: 'Drivetrain: \nRisk of overheating. Avoid high engine loads. Drive moderately.'
    },
    2739: {
        desc: 'Transmission \nmalfunction.',
        longDesc: ''
    },
    2740: {
        desc: '',
        longDesc: ''
    },
    2741: {
        desc: '',
        longDesc: ''
    },
    2742: {
        desc: 'License plate lamp \nmalfunction.',
        longDesc: 'License plate lamp malfunction: \nConsult nearest service center.'
    },
    2743: {
        desc: 'Left two-stage brake \nlamp malfunction.',
        longDesc: 'Left brake lamp: \nTwo-stage lamp malfunction. \nConsult nearest service center.'
    },
    2744: {
        desc: 'Right two-stage brake \nlamp malfunction.',
        longDesc: 'Right brake lamp: \nTwo-stage lamp malfunction. \nConsult nearest service center.'
    },
    2745: {
        desc: 'Camera-based \nassistance systems.',
        longDesc:
            'Camera-based system malfunction: \nHigh Beam Assistant malfunction. \nActivate/deactivate high beams manually. Consult service center.'
    },
    2747: {
        desc: 'Camera-based \nassistance systems.',
        longDesc:
            "Camera-based Systems: \nCamera-based systems deactivated. \nSensor's field of view reduced due to i.e. oncoming lights, rain, dirt, see Owner's Manual."
    },
    2748: {
        desc: 'Reduced sensitivity \nmode.',
        longDesc: "High beam assistant: \nReduced sensitivity mode activated. This mode may blind oncoming traffic. See Owner's Manual."
    },
    2749: {
        desc: 'Daytime/Parking \nlamp malfunction.',
        longDesc: 'Daytime/parking lamp malfunction: \nConsult nearest service center.'
    },
    2750: {
        desc: 'Daytime/Parking \nlamp malfunction.',
        longDesc: 'Daytime/Parking lamp malfunction: \nConsult nearest service center.'
    },
    2751: {
        desc: 'Static bend light \nmalfunction.',
        longDesc: 'Left cornering light malfunction: \nConsult nearest service center.'
    },
    2752: {
        desc: 'Static bend light \nmalfunction.',
        longDesc: 'Right cornering light malfunction: \nConsult nearest service center.'
    },
    2754: {
        desc: '',
        longDesc: ''
    },
    2760: {
        desc: 'Fasten safety belt.',
        longDesc: ''
    },
    2761: {
        desc: 'Fasten safety belt.',
        longDesc: ''
    },
    2764: {
        desc: 'Move shift lever \nto auto. position.',
        longDesc: ''
    },
    2765: {
        desc: 'Not possible to \nchange gear position.',
        longDesc: ''
    },
    2766: {
        desc: 'Activate parking \nbrake.',
        longDesc: "Parking brake: \nSecure vehicle against rolling. To reactivate, see Owner's Manual. Consult service center."
    },
    2768: {
        desc: 'Automatic Start/Stop \nmalfunction.',
        longDesc:
            'Automatic Start/Stop malfunction: \nEngine will not automatically turn on or off. Press Start/Stop button to start engine. Consult service center.'
    },
    2771: {
        desc: 'Engine oil level \nexceeds maximum.',
        longDesc: 'Engine oil level too high: \nYou can continue driving. \nAvoid high engine speeds. \nConsult service center.'
    },
    2773: {
        desc: 'In addition: \nPress brake pedal.',
        longDesc: ''
    },
    2774: {
        desc: 'Trailer: Tail light/ \nlicense plate lamp.',
        longDesc: ''
    },
    2775: {
        desc: 'Trailer, turn signal/ \nbrake lamp malfunction.',
        longDesc: ''
    },
    2776: {
        desc: 'Trailer, turn signal/ \nbrake lamp malfunction.',
        longDesc: ''
    },
    2777: {
        desc: 'Trailer: Check \nelectric brake.',
        longDesc: 'Trailer electric brake: \nMalfunction. Consult nearest service center.'
    },
    2781: {
        desc: '',
        longDesc: 'Parking brake: \nReduced. Consult service center.'
    },
    2785: {
        desc: 'Rear seat not \nlocked.',
        longDesc:
            "Left or right rear seat not locked: \nIncreased risk of injury in collision, as seat belt is ineffective. Engage left / right rear seat. See Owner's Manual."
    },
    2786: {
        desc: 'Start engine: \nBattery management.',
        longDesc: 'Battery discharging while stopped: \nStart engine. If fault persists, consult service center.'
    },
    2787: {
        desc: 'Trunk \npartition.',
        longDesc: 'Trunk partition: \nMove trunk partition into lower position.'
    },
    2790: {
        desc: 'Drivetrain \nmalfunction.',
        longDesc: ''
    },
    2791: {
        desc: 'Transm. malfunction: \nDrive moderately.',
        longDesc: ''
    },
    2793: {
        desc: 'Bottom tailgate.',
        longDesc:
            'Bottom tailgate section \nClose bottom tailgate section properly. \nIt will then be possible to close the top tailgate section with the automatic tailgate control.'
    },
    2794: {
        desc: 'Check trailer hitch.',
        longDesc:
            "Trailer hitch not secured: \nLock trailer hitch again, see Owner's Manual. If fault persists, do not use trailer. Consult service center."
    },
    2795: {
        desc: '',
        longDesc: 'Rear view camera: \nCheck camera lens and clean as required.'
    },
    2796: {
        desc: '',
        longDesc: 'Rear view camera malfunction: \nIf fault persists, consult service center.'
    },
    2798: {
        desc: 'Engine oil pressure: \nDrive moderately.',
        longDesc: ''
    },
    2799: {
        desc: '',
        longDesc: ''
    },
    2801: {
        desc: 'Transport mode.',
        longDesc: ''
    },
    2802: {
        desc: 'High braking load.',
        longDesc: 'High braking load: \nDrive moderately.'
    },
    2805: {
        desc: 'Seat calibration \nrequired.',
        longDesc: "Seat calibration required: \nSystem cannot detect the seat position. Please recalibrate, see Owner's Manual."
    },
    2806: {
        desc: 'Lane departure \nwarning.',
        longDesc: ''
    },
    2807: {
        desc: 'Seat position \ndetection malfunction.',
        longDesc: ''
    },
    2808: {
        desc: 'Roadside \nparking lamps on.',
        longDesc: ''
    },
    2810: {
        desc: 'Parking brake: \nShift into Park',
        longDesc: 'Parking brake overload: \nTo park, ensure the transmission is in Park.'
    },
    2813: {
        desc: 'Secure vehicle \nagainst rolling.',
        longDesc: "Active Cruise Control: \nVehicle may roll. Before leaving the vehicle, secure it against rolling. See Owner's Manual."
    },
    2814: {
        desc: 'Apply brakes yourself: \nAuto. Cruise Control.',
        longDesc: 'Cruise Control: \nVehicle is rolling. Apply the brakes. Keep your distance.'
    },
    2815: {
        desc: 'Fasten rear \nsafety belt.',
        longDesc: ''
    },
    2817: {
        desc: 'Launch Control \nactive.',
        longDesc: ''
    },
    2819: {
        desc: 'Fuel filter.',
        longDesc: ''
    },
    2820: {
        desc: 'Continue driving only \nwithout trailer connect.',
        longDesc: 'Trailer hitch: \nDo not drive with a trailer connected to the vehicle. Consult service center.'
    },
    2821: {
        desc: 'Automatic Start/Stop \ndeactivated.',
        longDesc:
            'Automatic Start/Stop deactivated: \nEngine will not start automatically. Press the Start/Stop button to start the engine.'
    },
    2822: {
        desc: 'Parking Assistant.',
        longDesc:
            'Parking Assistant malfunction: \nParking operation has been canceled. \nPlease park the vehicle manually. \nConsult service center.'
    },
    2823: {
        desc: 'In addition: \nPress brake pedal.',
        longDesc: ''
    },
    2826: {
        desc: 'Transm. in Neutral: \nVeh. cannot be locked.',
        longDesc: 'Transmission in Neutral. \nVehicle may roll away. It is not possible to lock the vehicle from outside.'
    },
    2827: {
        desc: 'Transm. will soon \nbe shifted into Park.',
        longDesc: ''
    },
    2828: {
        desc: 'Trailer lamp \nmalfunction.',
        longDesc:
            'Trailer electrics overload: \nTrailer not lit or only partially lit. Turn off electrical devices in trailer. If fault persists, consult service center.'
    },
    2829: {
        desc: 'Cont. driving possible: \nPedestrian protection.',
        longDesc: ''
    },
    2831: {
        desc: 'Replace battery.',
        longDesc: ''
    },
    2832: {
        desc: 'Battery: \nBattery charge %0',
        longDesc: ''
    },
    2834: {
        desc: 'Front passenger \nairbag deactivated.',
        longDesc: ''
    },
    2835: {
        desc: 'Restraint systems: \nAirbags disabled.',
        longDesc:
            'Restraint systems: \nAirbags, belt tensioners and belt force limiters disabled due to airbag ECU development software. Ensure safety belt is fastened.'
    },
    2837: {
        desc: 'Night Vision \nrestricted.',
        longDesc: "Night Vision: \nRestricted operation of Pedestrian/Animal Warning. See Owner's Manual."
    },
    2838: {
        desc: 'Selector lever.',
        longDesc:
            'Selector lever: \nChange in gear position possible without pressing the unlock button. If fault persists, consult service center.'
    },
    2839: {
        desc: '',
        longDesc: "Lane Departure Warning deactivated: \nReactivate Lane Departure Warning under suitable conditions. See Owner's Manual."
    },
    2841: {
        desc: '',
        longDesc: 'Top View camera: \nPlease clean camera, see Owner’s Manual.'
    },
    2842: {
        desc: '',
        longDesc: 'Camera system: \nPark and maneuver camera malfunction. \nConsult service center.'
    },
    2843: {
        desc: '',
        longDesc: 'Side View camera dirty: \nPlease clean, see Owner’s Manual.'
    },
    2844: {
        desc: '',
        longDesc: 'Side View camera malfunction: \nDisplay of blind spots not possible. Consult service center.'
    },
    2845: {
        desc: '',
        longDesc: 'Driving stability: \nDrive moderately. Consult nearest service center.'
    },
    2846: {
        desc: 'Emergency call \nsystem limited.',
        longDesc:
            'Emergency call restricted: \nFunction available but ability to locate vehicle by navigation is restricted or unavailable. Consult service center.'
    },
    2847: {
        desc: 'Active Blind Spot \nDetection.',
        longDesc: 'Active Blind Spot Detection malfunction: \nConsult service center.'
    },
    2848: {
        desc: 'Active Blind Spot \nDetection.',
        longDesc: "Active Blind Spot Detection deactivated: \nCheck the radar sensors' field of view. See Owner's Manual."
    },
    2850: {
        desc: 'Maintain safe distance: \nActive Cruise Control.',
        longDesc:
            "Active Cruise Control malfunction: \nMaintain safe distance. Conventional cruise control possible, see Owner's Manual. Consult service center."
    },
    2854: {
        desc: '',
        longDesc:
            "Active Cruise Control deactivated: \nDeactivated due to external fault. Maintain safe distance. Reactivate if desired. See Owner's Manual."
    },
    2855: {
        desc: 'Battery OK: \n%0',
        longDesc: ''
    },
    2856: {
        desc: 'Vehicle configuration \ninconsistent: Check.',
        longDesc: ''
    },
    2858: {
        desc: 'Lane departure \nwarning.',
        longDesc: "Lane Departure Warning: \nSensor may be obstructed. Please clean the sensor, see Owner's Manual."
    },
    2859: {
        desc: 'Parking Assistant.',
        longDesc: ''
    },
    2860: {
        desc: 'Parking Assistant.',
        longDesc: ''
    },
    2861: {
        desc: 'Parking Assistant.',
        longDesc:
            'Parking Assistant malfunction: \nParking operation has been canceled. \nPlease park the vehicle manually. \nConsult service center.'
    },
    2862: {
        desc: '',
        longDesc: ''
    },
    2866: {
        desc: 'Escape speed \nfunction used!',
        longDesc: ''
    },
    2867: {
        desc: 'Steering behavior \nchanged!',
        longDesc: ''
    },
    2868: {
        desc: 'Active Steering \nis being activated.',
        longDesc: 'Integrated Active Steering: \nTemporarily deactivated. Possible change in steering behavior. Moderate driving possible.'
    },
    2869: {
        desc: 'Steering behavior \nchanged!',
        longDesc: ''
    },
    2870: {
        desc: 'Reduce speed: \nTire chains.',
        longDesc:
            'Tire chains speed limit: \nMax. 30mph exceeded. Rear wheel steering will be reactivated at higher speeds. Possible damage if tire chains installed. Check "Tire chains" menu if necessary.'
    },
    2871: {
        desc: '',
        longDesc: ''
    },
    2872: {
        desc: 'Cont. driving possible: \nSteering.',
        longDesc: "Steering: \nDrive moderately. An Active Steering reset is required, see Owner's Manual."
    },
    2873: {
        desc: 'Cont. driving possible: \nIncreased steer. effort.',
        longDesc: 'Steering: \nDrive moderately. \nIncreased steering effort required. \nConsult service center.'
    },
    2874: {
        desc: 'Steering: \nDrive moderately.',
        longDesc: ''
    },
    2875: {
        desc: 'Steering behavior \nchanged!',
        longDesc: ''
    },
    2876: {
        desc: '',
        longDesc: ''
    },
    2878: {
        desc: 'Warning: High CO2 \nlevel in vehicle!',
        longDesc: ''
    },
    2879: {
        desc: 'Flashing beacons \nswitched on!',
        longDesc: ''
    },
    2880: {
        desc: 'Siren ready!',
        longDesc: ''
    },
    2881: {
        desc: 'Doors not locked.',
        longDesc: ''
    },
    2882: {
        desc: 'Protection systems \ninactive.',
        longDesc: ''
    },
    2883: {
        desc: 'Brake boost \nreduced.',
        longDesc: ''
    },
    2886: {
        desc: '',
        longDesc: ''
    },
    2887: {
        desc: 'Retractable top: \nOnly when parked',
        longDesc: 'Retractable top: \nOpening/closing retractable top only possible when parked.'
    },
    2888: {
        desc: '',
        longDesc: ''
    },
    2889: {
        desc: '',
        longDesc: ''
    },
    2890: {
        desc: 'Retractable top!',
        longDesc: "Retractable top: \nOpening/closing temporarily not possible. See Owner's Manual."
    },
    2891: {
        desc: 'Service indicator \nnot available.',
        longDesc: ''
    },
    2892: {
        desc: '',
        longDesc: ''
    },
    2893: {
        desc: '',
        longDesc: ''
    },
    2894: {
        desc: '',
        longDesc: ''
    },
    2895: {
        desc: '',
        longDesc: ''
    },
    2896: {
        desc: '',
        longDesc: ''
    },
    2897: {
        desc: '',
        longDesc: ''
    },
    2898: {
        desc: '',
        longDesc: ''
    },
    2899: {
        desc: '',
        longDesc: ''
    },
    2900: {
        desc: '',
        longDesc: ''
    },
    2901: {
        desc: '',
        longDesc: ''
    },
    2902: {
        desc: 'Distance control \ndeactivated.',
        longDesc: ''
    },
    2903: {
        desc: 'Distance control \nactivated.',
        longDesc: ''
    },
    2904: {
        desc: 'System available \nfrom %0 only.',
        longDesc: ''
    },
    2905: {
        desc: 'Cruise Control \ncannot be activated.',
        longDesc: ''
    },
    2906: {
        desc: 'Dangerous \ntraffic situation!',
        longDesc: ''
    },
    2907: {
        desc: 'Active Blind Spot \nDetection.',
        longDesc: "Active Blind Spot Detection: \nSystem deactivated. Reactivate under suitable conditions. See Owner's Manual."
    },
    2908: {
        desc: '',
        longDesc: ''
    },
    2913: {
        desc: '',
        longDesc: ''
    },
    2914: {
        desc: 'Front passenger \nairbag deactivated.',
        longDesc: 'Passenger airbag deactivated: \nSee Owner’s Manual.'
    },
    2915: {
        desc: 'Dangerous \ntraffic situation!',
        longDesc: ''
    },
    2916: {
        desc: 'Objects detected \non road!',
        longDesc: ''
    },
    2917: {
        desc: 'Objects detected \non road!',
        longDesc: ''
    },
    2918: {
        desc: 'Wrong-way driver!',
        longDesc: ''
    },
    2919: {
        desc: 'Wrong-way driver!',
        longDesc: ''
    },
    2920: {
        desc: 'Traffic jam!',
        longDesc: ''
    },
    2921: {
        desc: 'Traffic jam!',
        longDesc: ''
    },
    2922: {
        desc: 'Road closure!',
        longDesc: ''
    },
    2923: {
        desc: 'Road closure!',
        longDesc: ''
    },
    2924: {
        desc: 'Accident!',
        longDesc: ''
    },
    2925: {
        desc: 'Accident!',
        longDesc: ''
    },
    2926: {
        desc: 'People detected \non road!',
        longDesc: ''
    },
    2927: {
        desc: 'People detected \non road!',
        longDesc: ''
    },
    2928: {
        desc: 'Secure vehicle \nagainst rolling!',
        longDesc: 'Attention: \nBefore leaving the vehicle, secure it against rolling. Wear safety belt and close door while maneuvering.'
    },
    2929: {
        desc: 'Retractable top: \nCheck if locked.',
        longDesc: ''
    },
    2930: {
        desc: '',
        longDesc: ''
    },
    2931: {
        desc: '',
        longDesc: ''
    },
    2932: {
        desc: 'Manually close \nthe retractable top.',
        longDesc: "Retractable top malfunction: \nManual opening/closing possible. See Owner's Manual."
    },
    2933: {
        desc: 'Retractable top \nnot locked.',
        longDesc: "Retractable top not locked: \nPlease completely open or close top before driving. See Owner's Manual."
    },
    2934: {
        desc: 'Ventilation.',
        longDesc: 'Ventilation: \nMalfunction in fan or fresh air / recirculated air mode Consult service center.'
    },
    2936: {
        desc: 'Transmission in Park \nonly when stopped.',
        longDesc:
            'Transmission position: Park \nStop vehicle, shift into Park. Use only when stopped or risk damage to transmission. Consult service center.'
    },
    2937: {
        desc: 'Updating \nservice data.',
        longDesc: 'Updating service data: \nTransferring service data to remote control… Please wait.'
    },
    2938: {
        desc: 'Continued driving \npossible: Engine fan.',
        longDesc: ''
    },
    2939: {
        desc: 'Stop carefully: \nDrivetrain.',
        longDesc: ''
    },
    2940: {
        desc: 'Drivetrain: \nStop carefully.',
        longDesc: ''
    },
    2941: {
        desc: 'Cont. driving possible: \nDrivetrain.',
        longDesc: ''
    },
    2944: {
        desc: 'Transmission \nmalfunction.',
        longDesc: ''
    },
    2945: {
        desc: 'Cont. driving possible: \nRegenerative braking.',
        longDesc: 'Regenerative braking: \nNot available. Continued driving possible. Consult service center.'
    },
    2946: {
        desc: 'Ready to refuel \nat %0%.',
        longDesc: ''
    },
    2947: {
        desc: 'Tank ventilation. \nReduce speed.',
        longDesc: ''
    },
    2948: {
        desc: 'Refueling possible.',
        longDesc: ''
    },
    2949: {
        desc: 'Fuel filler \nflap open.',
        longDesc: 'Fuel filler flap open: \nClose the flap before driving.'
    },
    2950: {
        desc: 'Cont. driving possible: \nFuel tank system.',
        longDesc: ''
    },
    2951: {
        desc: 'Cont. driving possible: \nFuel tank system.',
        longDesc:
            "Fuel tank system malfunction: \nContinued driving possible. \nRelease fuel filler flap manually to refuel. \nSee Owner's Manual. \nConsult service center."
    },
    2952: {
        desc: '',
        longDesc: ''
    },
    2953: {
        desc: 'Active Blind Spot \nDetection.',
        longDesc: ''
    },
    2954: {
        desc: 'Hill Descent Control \ncannot be activated.',
        longDesc: 'Hill Descent Control: \nSystem cannot be activated. Reactivate under suitable driving conditions.'
    },
    2955: {
        desc: 'Cont. driving possible: \nTransport mode.',
        longDesc: 'Transport mode: \nFull engine power not available. Drive moderately. Consult service center.'
    },
    2956: {
        desc: 'High-voltage battery \nmalfunction.',
        longDesc: ''
    },
    2957: {
        desc: 'Vehicle \ncannot be restarted.',
        longDesc: ''
    },
    2958: {
        desc: '',
        longDesc: "High-voltage battery: \nCharge status too low for engine start. See Owner's Manual for instructions on jump-starting."
    },
    2959: {
        desc: 'To charge: \nSwitch on ignition.',
        longDesc:
            "High-voltage battery: \nSwitch on ignition to charge battery. Switch off electrical devices. See Owner's Manual for jump-starting."
    },
    2960: {
        desc: 'High-voltage battery \nnow charging.',
        longDesc:
            "High-voltage battery charging: \nMay require up to 30 minutes. Switch off unnecessary electrical devices. See Owner's Manual for jump-starting."
    },
    2961: {
        desc: 'Battery charging: \ncomplete.',
        longDesc: ''
    },
    2962: {
        desc: 'Battery charging: \ncanceled.',
        longDesc: "High-voltage battery: \nCharging canceled. For more information see Owner's Manual."
    },
    2963: {
        desc: 'Maintain safe distance: \nCruise Control.',
        longDesc:
            "Active Cruise Сontrol: \nActive Сruise Сontrol and Frontal Collision Warning System deactivated. \nMaintain safe distance. \nAbility to detect objects restricted. \nCheck the sensor and clean if necessary, see Owner's Manual."
    },
    2964: {
        desc: 'Maintain safe distance: \nCruise Control.',
        longDesc:
            'Active Cruise Control malfunction: \nFrontal Collision Warning System malfunction. Maintain safe distance. Consult service center.'
    },
    2965: {
        desc: 'Frontal Collision \nWarning.',
        longDesc: ''
    },
    2966: {
        desc: 'Frontal Collision \nWarning.',
        longDesc: 'Frontal Collision Warning System: \nInactive. Consult service center.'
    },
    2967: {
        desc: '',
        longDesc: "Lane Departure Warning deactivated: \nActive Blind Spot Detection reduced. Sensor may be dirty. See Owner's Manual."
    },
    2968: {
        desc: 'Lane departure \nwarning malfunction.',
        longDesc: 'Lane Departure Warning: \nSystem malfunction. Active Blind Spot Detection availability reduced. Consult service center.'
    },
    2969: {
        desc: '',
        longDesc:
            "Active Blind Spot Detection: \nDeactivated with Lane Departure Warning. Reactivate systems if desired. See Owner's Manual."
    },
    2970: {
        desc: 'Cont. driving possible: \nAct. Blind Spot Detect.',
        longDesc:
            'Active Blind Spot Detection: \nLane Departure Warning and Active Blind Spot Detection malfunction. Consult service center.'
    },
    2971: {
        desc: '',
        longDesc: ''
    },
    2972: {
        desc: 'Braking response: \nDrive moderately.',
        longDesc: ''
    },
    2973: {
        desc: 'Braking response: \nDrive moderately.',
        longDesc: ''
    },
    2974: {
        desc: 'Have the brake \nsystem checked.',
        longDesc: ''
    },
    2975: {
        desc: 'Stop carefully and \nturn off engine.',
        longDesc: ''
    },
    2977: {
        desc: 'High-voltage battery \npower output.',
        longDesc: ''
    },
    2979: {
        desc: 'Left front tire low!',
        longDesc:
            'Left front tire low: \nStop carefully and check tires. \nOn cars with run-flat tires ("RSC" symbol), the journey can be continued at speeds of up to 50 mph. See Owner\'s Manual.'
    },
    2980: {
        desc: 'Right front tire low!',
        longDesc:
            'Right front tire low: \nStop carefully and check tires. \nOn cars with run-flat tires ("RSC" symbol), the journey can be continued at speeds of up to 50 mph. See Owner\'s Manual.'
    },
    2981: {
        desc: 'Right rear tire low!',
        longDesc:
            'Right rear tire low: \nStop carefully and check tires. \nOn cars with run-flat tires ("RSC" symbol), the journey can be continued at speeds of up to 50 mph. See Owner\'s Manual.'
    },
    2982: {
        desc: 'Left rear tire low!',
        longDesc:
            'Left rear tire low: \nStop carefully and check tires. \nOn cars with run-flat tires ("RSC" symbol), the journey can be continued at speeds of up to 50 mph. See Owner\'s Manual.'
    },
    2983: {
        desc: '',
        longDesc: ''
    },
    2984: {
        desc: '',
        longDesc: ''
    },
    2985: {
        desc: '',
        longDesc: ''
    },
    2986: {
        desc: '',
        longDesc: ''
    },
    2987: {
        desc: '',
        longDesc: ''
    },
    2988: {
        desc: '',
        longDesc: ''
    },
    2989: {
        desc: '',
        longDesc: ''
    },
    2990: {
        desc: '',
        longDesc: ''
    },
    2991: {
        desc: '',
        longDesc: ''
    },
    2992: {
        desc: '',
        longDesc: ''
    },
    2993: {
        desc: '',
        longDesc: ''
    },
    2994: {
        desc: '',
        longDesc: ''
    },
    2995: {
        desc: '',
        longDesc: ''
    },
    2996: {
        desc: '',
        longDesc: ''
    },
    2997: {
        desc: '',
        longDesc: 'Frontal Collision Warning System: \nDeactivated. Maintain safe distance.'
    },
    2998: {
        desc: 'Steering response: \nDrive moderately.',
        longDesc: ''
    },
    2999: {
        desc: '',
        longDesc: ''
    },
    3000: {
        desc: 'Stop carefully and \nturn off engine.',
        longDesc: ''
    },
    3001: {
        desc: '',
        longDesc: ''
    },
    3002: {
        desc: 'Cruise Control \nactivated.',
        longDesc: ''
    },
    3003: {
        desc: 'Cruise Control \nactivated.',
        longDesc: ''
    },
    3004: {
        desc: 'Drivetrain \nmalfunction!',
        longDesc: ''
    },
    3005: {
        desc: 'Drivetrain \nmalfunction!',
        longDesc: ''
    },
    3006: {
        desc: 'Clutch: \nDrive moderately.',
        longDesc: ''
    },
    3007: {
        desc: 'High-voltage system \ndeactivated.',
        longDesc: ''
    },
    3008: {
        desc: 'Remote diagnosis \nactive.',
        longDesc: ''
    },
    3009: {
        desc: 'Stop carefully and \nturn off engine.',
        longDesc: ''
    },
    3017: {
        desc: 'Diesel exhaust \nfluid reserve.',
        longDesc: "Diesel exhaust fluid reserve: \nRefill diesel exhaust fluid at the next opportunity. \nRefer to Owner's Manual."
    },
    3018: {
        desc: 'Exhaust fluid range: \n%0',
        longDesc:
            "Refill exhaust fluid: \nPlease note remaining driving range. \nExhaust fluid must be refilled, otherwise starting the engine will no longer be possible. \nRefer to Owner's Manual."
    },
    3019: {
        desc: 'Exhaust fluid range: \n%0',
        longDesc:
            "Refill exhaust fluid: \nEngine start will not be possible without exhaust fluid. \nExhaust fluid must be refilled immediately, refer to Owner's Manual."
    },
    3020: {
        desc: 'Exhaust fluid range: \n%0',
        longDesc:
            'Exhaust fluid filling error: \nIncorrect exhaust fluid added. Engine start will not be possible when range reaches 0. Consult service center.'
    },
    3021: {
        desc: 'System malfunction: \nRange: %0',
        longDesc:
            'Exhaust fluid system: \nMalfunction. Engine start will not be possible when range reaches 0 miles. Consult service center.'
    },
    3023: {
        desc: 'Hold remote control \nto steering column.',
        longDesc: "Remote control: \nHold remote control to marking on steering column. See Owner's Manual for additional information."
    },
    3024: {
        desc: 'Remote detected: \nEngine can be started.',
        longDesc: ''
    },
    3025: {
        desc: 'Wear safety belt and \nclose door.',
        longDesc: ''
    },
    3026: {
        desc: 'To deactivate: \nPress brake pedal.',
        longDesc: ''
    },
    3027: {
        desc: '',
        longDesc: ''
    },
    3028: {
        desc: 'Chassis stabilization \nmalfunction!',
        longDesc: ''
    },
    3029: {
        desc: 'Chassis stabilization \nmalfunction!',
        longDesc: ''
    },
    3030: {
        desc: 'Chassis stabilization \nmalfunction!',
        longDesc: ''
    },
    3031: {
        desc: 'Chassis stabilization \nmalfunction!',
        longDesc: ''
    },
    3032: {
        desc: 'Chassis stabilization \nmalfunction!',
        longDesc: ''
    },
    3033: {
        desc: 'Chassis stabilization \nmalfunction!',
        longDesc: ''
    },
    3034: {
        desc: 'Check tire pressure: \nTPM reset required',
        longDesc:
            "Check tire pressure: \nCheck tire pressure and correct if necessary. \nAfterwards, perform Tire Pressure Monitor reset (TPM). \nSee Owner's Manual for further information."
    },
    3035: {
        desc: '',
        longDesc:
            'TPM temporarily inactive: \nTire Pressure Monitor temporarily inactive due to external interference (e.g. TV/radio transmitters, wireless headphones). \nUnable to detect tire pressure loss. Drive moderately.'
    },
    3036: {
        desc: 'Diesel exhaust fluid: \nRange: %0',
        longDesc:
            "Diesel exhaust fluid reserve: \nPlease note remaining driving range. Refill diesel exhaust fluid as soon as possible. See Owner's Manual."
    },
    3037: {
        desc: 'Diesel exhaust fluid: \nNo start in: %0',
        longDesc:
            "Exhaust fluid at minimum level: \nEngine start not possible when range reaches 0. Refill immediately. See Owner's Manual."
    },
    3038: {
        desc: 'Diesel exhaust fluid: \nNo start in: %0',
        longDesc:
            "Refill diesel exhaust fluid: \nEngine start will not be possible without refilling diesel exhaust fluid. See Owner's Manual."
    },
    3039: {
        desc: 'Incorrect fluid: \nNo start in: %0',
        longDesc: ''
    },
    3040: {
        desc: 'Tire chains \ninstalled.',
        longDesc:
            'Tire chains installed: \nRear wheel steering deactivated. Max. 30 mph with tire chains. Check "Tire chains" menu if necessary.'
    },
    3041: {
        desc: '',
        longDesc: ''
    },
    3043: {
        desc: '',
        longDesc: ''
    },
    3045: {
        desc: '',
        longDesc: ''
    },
    3046: {
        desc: '',
        longDesc: ''
    },
    3048: {
        desc: '',
        longDesc: ''
    },
    3049: {
        desc: '',
        longDesc: ''
    },
    3050: {
        desc: '',
        longDesc: ''
    },
    3051: {
        desc: '',
        longDesc: ''
    },
    3052: {
        desc: '',
        longDesc: ''
    },
    3053: {
        desc: '',
        longDesc: ''
    },
    3054: {
        desc: '',
        longDesc: ''
    },
    3056: {
        desc: 'High-voltage battery: \n%0 charged.',
        longDesc: ''
    },
    3057: {
        desc: 'High-voltage battery \nOK. %0',
        longDesc: ''
    },
    3058: {
        desc: 'Replace \nhigh-voltage battery.',
        longDesc: ''
    },
    3059: {
        desc: '',
        longDesc:
            'Active Blind Spot Detection: \nDeactivated due to overheating of vibration mechanism. Lane Departure Warning deactivated. Reactivate after cooling down.'
    },
    3060: {
        desc: '',
        longDesc: 'Active Blind Spot Detection: \nDeactivated due to overheating of vibration mechanism. Reactivate after cooling down.'
    },
    3061: {
        desc: '',
        longDesc: 'Lane Departure Warning: \nDeactivated due to overheating of vibration mechanism. Reactivate after cooling down.'
    },
    3063: {
        desc: '',
        longDesc: ''
    },
    3069: {
        desc: 'Transmission position \n"Park" malfunction.',
        longDesc: ''
    },
    3073: {
        desc: 'Diesel exhaust fluid: \nService due.',
        longDesc:
            'Diesel exhaust fluid: \nService due. Please have the diesel exhaust fluid changed due to fluid age. Consult service center.'
    },
    3074: {
        desc: 'Please drive.',
        longDesc: ''
    },
    3075: {
        desc: 'Hard disc drive.',
        longDesc: "Hard disc drive malfunction: \nSee Owner's Manual for additional information on data backup. Consult service center."
    },
    3076: {
        desc: 'Shift into Park.',
        longDesc: ''
    },
    3077: {
        desc: 'Press brake pedal \nor clutch.',
        longDesc: ''
    },
    3078: {
        desc: '',
        longDesc: ''
    },
    3079: {
        desc: 'Cooling system: \nDrive moderately.',
        longDesc: ''
    },
    3088: {
        desc: 'To select gear: \nPress unlock button.',
        longDesc: 'Select gear: \nTo select a gear, press unlock button on gear selector and press brake pedal.'
    },
    3089: {
        desc: 'It may not be possible \nto start engine.',
        longDesc: ''
    },
    3090: {
        desc: 'Press Start/Stop \nagain.',
        longDesc: 'Engine start: \nPress Start/Stop button again to start engine. If fault persists, consult service center.'
    },
    3091: {
        desc: 'Maintain safe distance: \nCruise Control.',
        longDesc:
            "Active Cruise Control malfunction: \nFrontal Collision Warning System affected. Maintain safe distance. Conventional cruise control possible, see Owner's Manual. Consult service center."
    },
    3097: {
        desc: 'Parking brake.',
        longDesc: 'Parking brake malfunction: \nSecure vehicle from rolling when parked. Consult service center.'
    },
    3098: {
        desc: '',
        longDesc: ''
    },
    3103: {
        desc: 'Secure vehicle \nagainst rolling.',
        longDesc: 'Parking brake: \nRoadway too steep. \nSecure vehicle against rolling.'
    },
    3104: {
        desc: 'Shift into Park.',
        longDesc: 'Transmission not in Park: \nVehicle may roll. It is not possible to lock vehicle from outside.'
    },
    3105: {
        desc: 'Automatic Start/Stop \nmalfunction!',
        longDesc: ''
    },
    3106: {
        desc: 'Automatic Start/Stop \ndeactivated!',
        longDesc:
            'Automatic Start/Stop deactivated: \nMotor will not automatically switch on or off. If necessary, press Start/Stop button to start engine.'
    },
    3107: {
        desc: '',
        longDesc: ''
    },
    3108: {
        desc: 'Engine compartm. hot: \nOpen carefully.',
        longDesc:
            'Engine compartment hot: \nCaution: Components and fluids hot. Let engine cool down before opening hood. Use caution when opening.'
    },
    3126: {
        desc: '',
        longDesc: ''
    },
    3127: {
        desc: 'Steering wheel \nlock malfunction.',
        longDesc: 'Steering wheel lock: \nSteering wheel could not be locked. \nIf fault persists, consult service center.'
    },
    3128: {
        desc: 'Distance information.',
        longDesc: ''
    },
    3129: {
        desc: 'Door closing power \nassist deactivated.',
        longDesc:
            'Door closing power assist: \nVehicle incline too large for door closing power assist. Function will be available once vehicle is level.'
    },
    3130: {
        desc: 'Door malfunction.',
        longDesc: 'Door malfunction: \nDoor not fully latched. Consult service center.'
    },
    3131: {
        desc: 'Motor cannot \ncurrently be started.',
        longDesc: ''
    },
    3132: {
        desc: 'Remaining trip time: \n%0 min.',
        longDesc: ''
    },
    3133: {
        desc: 'Drivetrain \nmalfunction.',
        longDesc: ''
    },
    3134: {
        desc: '',
        longDesc: ''
    },
    3135: {
        desc: 'Test mode end: \nswitch off ignition.',
        longDesc:
            'Test mode \nTest mode operating status activated. \nThis operating status is not suitable for use on the road and only provided for service staff. \nSwitch off ignition to deactivate test mode.'
    },
    3136: {
        desc: '',
        longDesc:
            'Frontal Collision Warning System: \nMalfunction. Brake intervention not available. Visual and acoustic warnings active. Consult service center.'
    },
    3137: {
        desc: 'Speed limit control \nactivated.',
        longDesc: ''
    },
    3138: {
        desc: 'Cont. driving possible: \nSpeed limit.',
        longDesc: 'Speed limit malfunction: \nConsult service center.'
    },
    3139: {
        desc: 'Speed limit \nexceeded.',
        longDesc: ''
    },
    3140: {
        desc: 'Speed limit control \ncannot be activated.',
        longDesc: 'Speed limit cannot be activated: \nNecessary conditions for operation are currently unavailable.'
    },
    3142: {
        desc: 'Ignition switched on.',
        longDesc: ''
    },
    3143: {
        desc: '',
        longDesc: ''
    },
    3144: {
        desc: 'No restart \nafter engine stop.',
        longDesc: ''
    },
    3145: {
        desc: '',
        longDesc: ''
    },
    3146: {
        desc: 'Independent venti-\nlation deactivated.',
        longDesc:
            "Heating/cooling: \nComfort heating/cooling deactivated to ensure the starting of the vehicle. See Owner's Manual for more information."
    },
    3147: {
        desc: 'Start engine only \nwith no gear engaged.',
        longDesc: 'Engine start: \nOnly possible when no gear is engaged. If fault persists, consult service center.'
    },
    3148: {
        desc: 'Cont. driving possible: \nClutch temperature.',
        longDesc:
            'High clutch temperature: \nYou can continue driving. \nClutch is not damaged. \nAllow clutch to cool down, \ne.g. when parked or while driving at moderate speed. \nDuring cooling avoid frequent stop and go. \nClutch has cooled down after message disappears.'
    },
    3151: {
        desc: 'Rear axle \ndifferential lock.',
        longDesc: 'Rear axle differential lock: \nDriving stability limited.'
    },
    3152: {
        desc: 'Rear axle \ndifferential lock.',
        longDesc: 'Rear axle differential lock: \nDriving stability limited.'
    },
    3154: {
        desc: 'Frontal Collision \nWarning.',
        longDesc:
            "Frontal Collision Warning System: \nFrontal Collision Warning System limited. \nFront camera's field of view reduced due to i.e. oncoming lights, rain, dirt, see Owner's Manual."
    },
    3155: {
        desc: 'High beam assistant.',
        longDesc: "Front camera: \nCheck for obstruction. Restricted functionality of camera-based systems. See Owner's Manual."
    },
    3156: {
        desc: 'High beam assistant.',
        longDesc: 'Front camera malfunction: \nFront camera based assistance systems malfunction. Consult service center.'
    },
    3157: {
        desc: 'Cont. driving possible: \nPedestrian Protection.',
        longDesc: ''
    },
    3158: {
        desc: 'Break recommended.',
        longDesc: 'Would you like to take a break?'
    },
    3159: {
        desc: '',
        longDesc: ''
    },
    3160: {
        desc: 'Driving stabilization \nis being activated.',
        longDesc:
            'Driving stabilization: \nDrive moderately. Initialization in progress. Driving stabilization will be available after automatic initialization.'
    },
    3161: {
        desc: 'Emergency release: \nFor maneuvering only.',
        longDesc:
            "Drivetrain emergency release: \nOnly transport vehicle on a loading platform. \nRisk of vehicle damage if towed. \nVehicle may be maneuvered briefly in accordance with the instructions in the Owner's Manual."
    },
    3162: {
        desc: 'Stop carefully: \nDrivetrain.',
        longDesc: ''
    },
    3163: {
        desc: 'Drivetrain: \nDrive moderately.',
        longDesc: 'Drivetrain malfunction: \nDrive moderately. Maximum drivetrain output not available. Consult service center.'
    },
    3165: {
        desc: 'Cont. driving possible: \nDrivetrain.',
        longDesc: 'Drivetrain malfunction: \nContinued driving is possible. \nConsult service center.'
    },
    3166: {
        desc: 'Drivetrain: \nDrive moderately',
        longDesc: 'Drivetrain: \nMaximum permitted speed exceeded. Reduce speed to prevent engine damage.'
    },
    3167: {
        desc: '',
        longDesc: ''
    },
    3171: {
        desc: '',
        longDesc: 'Drivetrain malfunction: \nDrive moderately. \nMaximum drivetrain output not available.'
    },
    3172: {
        desc: 'Braking response: \nDrive moderately.',
        longDesc: ''
    },
    3173: {
        desc: 'Check \ncharging cable.',
        longDesc: 'Check charging cable: \nCharging cable connector may not be locked into place correctly. \nReconnect charging cable.'
    },
    3174: {
        desc: 'Insufficient \ngrid power.',
        longDesc: 'Insufficient grid power: \nUnable to charge.'
    },
    3175: {
        desc: 'Unable to charge.',
        longDesc: 'Unable to charge: \nNote remaining range. Consult service center.'
    },
    3176: {
        desc: 'Range \n%0',
        longDesc: ''
    },
    3177: {
        desc: 'Range \n%0',
        longDesc: ''
    },
    3178: {
        desc: 'Disconnect \ncharging cable.',
        longDesc: 'Disconnect charging cable: \nDisconnect charging cable and close charging flap to activate ready-to-drive.'
    },
    3179: {
        desc: 'Check \ncharging cable.',
        longDesc: 'Charging cable cannot be detected. \nCheck if charging cable is disconnected. Consult service center.'
    },
    3180: {
        desc: '',
        longDesc: ''
    },
    3181: {
        desc: 'Drivetrain \nmalfunction.',
        longDesc: ''
    },
    3182: {
        desc: 'Stop carefully: \nHood open.',
        longDesc: ''
    },
    3183: {
        desc: 'Distance information.',
        longDesc: "Distance information: \nNot available. \nSensor dirty. \nPlease clean sensor, see Owner's Manual."
    },
    3184: {
        desc: '',
        longDesc: 'Dynamic Light Spot Highbeam: \nMalfunction. Consult service center.'
    },
    3185: {
        desc: 'Dynamic Marker Light \nmalfunction.',
        longDesc: 'Dynamic Light Spot malfunction: \nHighbeam malfunction. Consult service center.'
    },
    3186: {
        desc: 'Lighting system: \nFront left malfunction.',
        longDesc:
            'Lighting system malfunction: \nStop carefully, check lights and if necessary, continue driving. Consult nearest service center.'
    },
    3187: {
        desc: 'Lighting system: Front \nright malfunction.',
        longDesc:
            'Lighting system malfunction: \nStop carefully, check lights and if necessary, continue driving. Consult nearest service center.'
    },
    3188: {
        desc: 'Lighting system: \nFront left malfunction.',
        longDesc:
            'Lighting system malfunction: \nStop carefully, check lights and if necessary, continue driving. Consult nearest service center.'
    },
    3189: {
        desc: 'Lighting system: Front \nright malfunction.',
        longDesc:
            'Lighting system malfunction: \nStop carefully, check lights and if necessary, continue driving. Consult nearest service center.'
    },
    3190: {
        desc: 'Lighting system: \nStop carefully.',
        longDesc:
            'Lighting system malfunction: \nStop carefully, check lights and if necessary, continue driving. Consult nearest service center.'
    },
    3191: {
        desc: '',
        longDesc: ''
    },
    3192: {
        desc: '',
        longDesc: ''
    },
    3193: {
        desc: 'Rear spoiler.',
        longDesc: "Rear spoiler malfunction: \nVehicle may be unstable at speeds above 80 mph. See Owner's Manual."
    },
    3194: {
        desc: '',
        longDesc: ''
    },
    3195: {
        desc: 'To start engine: \nShift into Park.',
        longDesc: ''
    },
    3196: {
        desc: '',
        longDesc: ''
    },
    3197: {
        desc: 'Lighting system: \nFront left malfunction.',
        longDesc: 'Lighting system: \nCheck lights and drive carefully. Consult service center.'
    },
    3198: {
        desc: 'Lighting system: Front \nright malfunction.',
        longDesc: 'Lighting system: \nCheck lights and drive carefully. Consult service center.'
    },
    3199: {
        desc: 'Vehicle is \nready-to-drive.',
        longDesc: 'Vehicle ready: \nTo drive, close all doors. \nTo exit vehicle, shift into Park and press Start/Stop button.'
    },
    3200: {
        desc: 'Active Cruise Control.',
        longDesc:
            'Active Cruise Control limited: \nApply brakes manually. No reaction to stationary objects. Check front camera, see Owner’s Manual.'
    },
    3201: {
        desc: '',
        longDesc: ''
    },
    3202: {
        desc: 'Only with light switch \nin position "A".',
        longDesc: ''
    },
    3203: {
        desc: 'High-voltage system \ndeactivated.',
        longDesc: ''
    },
    3204: {
        desc: 'Check battery \ncharge status.',
        longDesc: ''
    },
    3205: {
        desc: 'Vehicle is \nready-to-drive.',
        longDesc: 'Vehicle ready: \nTo drive, close all doors. \nTo exit vehicle, shift into Park and press Start/Stop button.'
    },
    3206: {
        desc: 'Parking assistance.',
        longDesc: ''
    },
    3207: {
        desc: '',
        longDesc: ''
    },
    3208: {
        desc: '',
        longDesc: ''
    },
    3209: {
        desc: '0',
        longDesc: ''
    },
    3210: {
        desc: 'Steering Assistant.',
        longDesc: 'Traffic Jam Assist \nTraffic Jam Assist malfunction. \nIf fault persists, consult service center.'
    },
    3211: {
        desc: 'Steering Assistant \navailable up to %0',
        longDesc: ''
    },
    3212: {
        desc: 'Steering Assistant \ncannot be activated.',
        longDesc: ''
    },
    3213: {
        desc: '',
        longDesc: ''
    },
    3214: {
        desc: 'Steering Assistant \ndeactivated.',
        longDesc: 'Traffic Jam Assist: \nTraffic Jam Assist temporarily unavailable. \nPlease check camera lens.'
    },
    3215: {
        desc: 'Cont. driving possible: \nDrivetrain.',
        longDesc: ''
    },
    3216: {
        desc: 'Exhaust fluid \nfilling error.',
        longDesc: 'Exhaust fluid filling error: \nIncorrect diesel exhaust fluid added. \nConsult service center.'
    },
    3217: {
        desc: 'Exhaust fluid system: \nNo re-start: %0 miles.',
        longDesc: ''
    },
    3218: {
        desc: 'Exhaust fluid system.',
        longDesc: 'Exhaust fluid system malfunction. \nConsult service center.'
    },
    3219: {
        desc: '',
        longDesc: ''
    },
    3220: {
        desc: 'Pedestrian \nWarning.',
        longDesc: 'Pedestrian Warning: \nMalfunction. Consult service center.'
    },
    3221: {
        desc: 'Pedestrian \nWarning.',
        longDesc:
            'Daytime Pedestrian Warning limited. \nBrake intervention not possible, but visual and acoustic warnings are still given. Consult service center.'
    },
    3222: {
        desc: 'Pedestrian \nWarning.',
        longDesc:
            "Daytime Pedestrian Warning limited. \nFront camera's field of view reduced due to i.e. oncoming lights, rain, dirt, see Owner's Manual."
    },
    3223: {
        desc: '',
        longDesc: 'Drivetrain malfunction: \nContinued driving is possible. \nConsult service center.'
    },
    3224: {
        desc: 'Comfort Loading: \nStop carefully.',
        longDesc: "Comfort Loading \nLower loading aid before driving. \nSee Owner's Manual."
    },
    3225: {
        desc: 'Total driving range: \n%0',
        longDesc: ''
    },
    3226: {
        desc: 'Total driving range: \n%0',
        longDesc: ''
    },
    3227: {
        desc: 'Battery capacity <= 12,5 %',
        longDesc: ''
    },
    3228: {
        desc: 'Unable to close: \nRemote missing.',
        longDesc: ''
    },
    3229: {
        desc: 'Trailer detected: \nOpen manually.',
        longDesc: ''
    },
    3230: {
        desc: 'Charging station \nmalfunction.',
        longDesc: ''
    },
    3231: {
        desc: '',
        longDesc: ''
    },
    3232: {
        desc: 'Door lock malfunction.',
        longDesc: ''
    },
    3233: {
        desc: 'Range %0',
        longDesc:
            'Short range: \nAvoid passing. \nWhen tank is empty, driving mode MAX eDRIVE is activated and the engine power is reduced.'
    },
    3234: {
        desc: 'Range %0',
        longDesc: ''
    },
    3235: {
        desc: 'Charge status: Low.',
        longDesc: ''
    },
    3236: {
        desc: '',
        longDesc: ''
    },
    3237: {
        desc: '',
        longDesc: ''
    },
    3238: {
        desc: '',
        longDesc: ''
    },
    3239: {
        desc: 'Braking assistance.',
        longDesc: 'Parking assistance. \nNo brake intervention for parking assistance. \nBrake the vehicle manually and secure vehicle.'
    },
    3240: {
        desc: 'Roof: Trunk has been \nloaded incorrectly.',
        longDesc: "Roof \nClose convertible roof completely. \nCheck trunk for incorrect loading, see Owner's Manual."
    },
    3241: {
        desc: 'Emission inspection \nmode activated.',
        longDesc:
            'Emission inspection mode activated: \nSee repair instructions or product description. \nEmission inspection mode will end automatically when journey is started or ignition is switched off.'
    },
    3242: {
        desc: 'Emission inspection \nmode not possible.',
        longDesc:
            'Emission inspection mode not possible: \nBattery charge too high. Reduce battery charge. \nSee repair instructions or product description.'
    },
    3243: {
        desc: 'Vehicle cannot \nbe lowered.',
        longDesc: ''
    },
    3244: {
        desc: 'AC charging \nnot possible.',
        longDesc:
            "AC charging not possible: \nError in the vehicle's AC charging system. \nPlease note remaining driving range. \nConsult nearest service center."
    },
    3245: {
        desc: 'DC Fast charging \nnot possible.',
        longDesc:
            'DC Fast charging not possible: \nStandard charging still possible. \nPlease note remaining driving range. \nConsult nearest service center.'
    },
    3246: {
        desc: 'Charging socket \nflap open.',
        longDesc: 'Charging socket flap open: \nClose flap before starting journey.'
    },
    3247: {
        desc: 'Cont. driving possible: \nDriver assistance.',
        longDesc:
            'Driver assistance \nDriver assistance malfunction. \nKeep your distance and stay in lane. \nHave the problem checked by service center.'
    },
    3248: {
        desc: 'Acoustic Pedestrian \nProtection malfunction.',
        longDesc: ''
    },
    3249: {
        desc: '',
        longDesc: 'Panorama View \nCheck Panorama View camera lens and clean as required.'
    },
    3250: {
        desc: 'Engine can be started \nin %0 minutes.',
        longDesc:
            'Engine cannot be started: \nSwitch off ignition. \nBattery will start charging on its own. \nIt will be possible to start engine shortly.'
    },
    3251: {
        desc: 'Independent venti-\nlation deactivated.',
        longDesc: 'Heating/cooling: \nComfort heating/ventilation deactivated. \nHigh-voltage battery not sufficiently charged.'
    },
    3252: {
        desc: 'Independent venti-\nlation deactivated.',
        longDesc:
            'Independent ventilation deactivated \nVehicle was not started because the programmed departure time was skipped several times.'
    },
    3253: {
        desc: 'Secure vehicle \nagainst rolling.',
        longDesc: 'Secure vehicle against rolling: \nVehicle may roll away or drive off.'
    },
    3254: {
        desc: 'Parking \nassistance.',
        longDesc:
            'Parking assistance: \nNo parking assistance, please park unaided. \nParking assistance deactivated due to a temporary external fault.'
    },
    3255: {
        desc: 'DC Fast charging \nactive.',
        longDesc: ''
    },
    3256: {
        desc: 'Charging with \nreduced power.',
        longDesc:
            'Charging with reduced power: \nCharging power is occasionally reduced to protect in-vehicle systems. \nIf charging restriction persists, consult service center.'
    },
    3257: {
        desc: 'Vehicle detection \nrestricted.',
        longDesc:
            'Vehicle detection restricted: \nActive Cruise Control deactivated systemically. \nMaintain safe distance. \nReactivate Cruise Control if required.'
    },
    3258: {
        desc: 'Not fully charged \nby departure time.',
        longDesc:
            'High-voltage battery not fully charged at departure time: \nCharging time too short or climate/comfort requirements too high.'
    },
    3259: {
        desc: 'Auto PDC malfunction.',
        longDesc: 'Auto PDC malfunction: \nActivate PDC manually. \nConsult service center.'
    },
    3260: {
        desc: '',
        longDesc: ''
    },
    3261: {
        desc: '',
        longDesc: ''
    },
    3262: {
        desc: '',
        longDesc: 'Traffic Jam Assist: \nTraffic Jam Assist only available on expressways and major highways.'
    },
    3263: {
        desc: 'Activate Cruise \nControl first.',
        longDesc: ''
    },
    3264: {
        desc: 'Activate Cruise \nControl first.',
        longDesc: ''
    },
    3265: {
        desc: 'Oil dilution critical: \nDrive moderately.',
        longDesc: 'Oil dilution critical: \nDrive moderately. \nConsult service center.'
    },
    3266: {
        desc: 'Oil dilution critical: \nDrive moderately.',
        longDesc:
            'Oil dilution: \nIncreased proportion of ethanol in engine oil. \nDrive moderately. \nAvoid driving short distances at low outside temperatures.'
    },
    3267: {
        desc: 'Do not cont. driving: \nSteering malfunction.',
        longDesc: ''
    },
    3268: {
        desc: 'Range Extender: \nMaintenance cycle.',
        longDesc:
            'Range Extender: \nMaintenance cycle will start shortly. \nPossible to continue your journey. \nMaintenance cycle required due to prolonged period of non-use.'
    },
    3269: {
        desc: 'Mainten. cycle active: \nRemain. time %0 min.',
        longDesc:
            'Maintenance cycle active: \nPossible to continue your journey. \nRange Extender maintenance cycle was activated automatically.'
    },
    3270: {
        desc: 'Range Extender.',
        longDesc:
            'Range Extender: \nMaintenance cycle required due to a prolonged period of non-use. \nMaintenance cycle will start automatically with a filled tank and battery charge below 75%.'
    },
    3271: {
        desc: 'Charge status: Low. \nHigh-voltage battery.',
        longDesc:
            'Battery charge low: \nCharge battery before leaving vehicle parked for prolonged periods to prevent possible damage to battery.'
    },
    3272: {
        desc: '',
        longDesc:
            'Dynamic Stability Control: \nDynamic Stability Control inactive. \nDynamic driving without driving stabilization. \nLimited driver assistance.'
    },
    3273: {
        desc: '',
        longDesc:
            'Dynamic Traction Control: \nDynamic Traction Control activated. \nMaximum traction on loose surfaces. \nLimited driving stabilization and driver assistance.'
    },
    3274: {
        desc: 'Parking assistance: \nBrake veh. manually.',
        longDesc: ''
    },
    3275: {
        desc: 'Parking brake or \nshift into Park.',
        longDesc:
            'Parking brake or shift into Park: \nApply parking brake or shift into Park. \nVehicle is currently being held by the electric motor. \nTo save energy when stopped for longer periods, apply the parking brake or shift into Park.'
    },
    3276: {
        desc: 'Transmission position \nPark engaged.',
        longDesc:
            'Transmission position Park engaged: \nTransmission position Park was engaged automatically. \nTo drive away, press brake pedal and select gear.'
    },
    3277: {
        desc: 'Engine turned off \nautomatically.',
        longDesc: 'Engine turned off automatically: \nThe engine was turned off automatically after 30 min.'
    },
    3278: {
        desc: 'Brake pad \nwear sensor.',
        longDesc: 'Brake pad wear sensor: \nBrake pads need to be replaced. \nConsult service center.'
    },
    3279: {
        desc: 'Fuel tank empty: \nReduced power.',
        longDesc:
            'Tank empty: \nMAX eDRIVE driving mode activated. \nFull drive performance not available. \nRefuel for full drive performance. \nMAX eDRIVE driving mode cannot be changed while tank empty.'
    },
    3280: {
        desc: 'Cont. driving possible: \nSteering assistant.',
        longDesc: ''
    },
    3281: {
        desc: '',
        longDesc: 'Traffic Jam Assist: \nTraffic Jam Assist only available on expressways and major highways.'
    },
    3282: {
        desc: 'Finish test section.',
        longDesc:
            'Finish test section \nTake foot off accelerator. \nFor battery discharge procedure: shift transmission to N, brake the vehicle to a stop. \nFor electric range procedure: leave transmission in D, let the vehicle coast to a stop, do not brake until speed falls below 10 km/h (6 mph). \nWhen vehicle is stationary: switch off ignition.'
    },
    3283: {
        desc: 'Showroom mode.',
        longDesc: ''
    },
    3284: {
        desc: 'Limited driver \nassistance.',
        longDesc: ''
    },
    3285: {
        desc: 'Limited driver \nassistance.',
        longDesc: ''
    },
    3286: {
        desc: 'Active Protection \nlimited.',
        longDesc: ''
    },
    3287: {
        desc: 'Please add \nengine oil.',
        longDesc: "Engine oil at minimum level: \nAdd 2 quarts of oil as soon as possible, see Owner's Manual."
    },
    3288: {
        desc: 'Oil below minimum. \nRefill immediately.',
        longDesc:
            "Engine oil level below minimum: \nContinued driving may cause engine damage. Add 2 quarts of oil immediately. See Owner's Manual."
    },
    3289: {
        desc: 'Parking assistance \nmalfunction.',
        longDesc: ''
    },
    3290: {
        desc: 'Parking assistance \nlimited.',
        longDesc: ''
    },
    3291: {
        desc: 'Limited driver \nassistance.',
        longDesc: ''
    },
    3292: {
        desc: 'Limited driver \nassistance.',
        longDesc: ''
    },
    3293: {
        desc: 'Cont. driving possible: \nDriver assistance.',
        longDesc: ''
    },
    3294: {
        desc: '',
        longDesc:
            'Battery charge low \nBattery charge low because vehicle was parked with ignition switched on. \nTo avoid this, shift into Park after parking.'
    },
    3295: {
        desc: 'Right secondary \nblinker malfunction.',
        longDesc: ''
    },
    3296: {
        desc: 'Left secondary \nblinker malfunction.',
        longDesc: ''
    },
    3297: {
        desc: 'Steering wheel \nheating activated.',
        longDesc: ''
    },
    3298: {
        desc: 'Steering wheel \nheating deactivated.',
        longDesc: ''
    },
    3299: {
        desc: '',
        longDesc:
            'Battery charge very low. \nBattery charge very low because vehicle was parked with ignition switched on. \nTo avoid this, shift into Park after parking. \nCharge by driving for longer periods or use external charger. \nFunctions requiring battery may be temporarily switched off.'
    },
    3300: {
        desc: '',
        longDesc: ''
    },
    3301: {
        desc: '',
        longDesc: ''
    },
    3302: {
        desc: 'Side collision warning.',
        longDesc: ''
    },
    3303: {
        desc: 'Side collision warning.',
        longDesc: ''
    },
    3304: {
        desc: 'Active Blind \nSpot Detection.',
        longDesc: ''
    },
    3305: {
        desc: 'Lane departure \nwarning.',
        longDesc: ''
    },
    3306: {
        desc: 'Lane departure \nwarning.',
        longDesc: ''
    },
    3307: {
        desc: 'Center brake \nlamp malfunction.',
        longDesc: ''
    },
    3310: {
        desc: 'Fog light/bend \nlight malfunction.',
        longDesc: ''
    },
    3311: {
        desc: 'Fog light/bend \nlight malfunction.',
        longDesc: ''
    },
    3312: {
        desc: 'Auto lighting and \nwiping system malfunct.',
        longDesc: ''
    },
    3313: {
        desc: 'Front side marker \nlight malfunction.',
        longDesc: ''
    },
    3314: {
        desc: 'Front side marker \nlight malfunction.',
        longDesc: ''
    },
    3315: {
        desc: 'Daytime driving \nlights malfunction.',
        longDesc: ''
    },
    3316: {
        desc: 'Daytime driving \nlights malfunction.',
        longDesc: ''
    },
    3317: {
        desc: 'Roadside \nparking lamps off.',
        longDesc: ''
    },
    3318: {
        desc: 'Left roadside parking \nlamps on.',
        longDesc: ''
    },
    3319: {
        desc: 'Right roadside parking \nlamps on.',
        longDesc: ''
    },
    3320: {
        desc: 'Roadside park. lamps \ncannot be activated.',
        longDesc: ''
    },
    3321: {
        desc: 'Cont. driving possible: \nSide collision warning.',
        longDesc: ''
    },
    3322: {
        desc: 'Mobile device in \nwireless charging tray.',
        longDesc: ''
    },
    3323: {
        desc: 'Intelligent Safety \ndeactivated.',
        longDesc: ''
    },
    3324: {
        desc: 'Safe Share \ndetected.',
        longDesc: ''
    },
    3325: {
        desc: 'Active Cruise Control.',
        longDesc: ''
    },
    3326: {
        desc: 'Tire pressure \nnotification.',
        longDesc:
            "Tire pressure notification: \nYou can continue driving. \nTire pressure is slightly lowered. \nInflate tires at your convenience. \nAfterwards, reset Tire Pressure Monitor \n(TPM). \nSee Owner's Manual \nfor more information."
    },
    3327: {
        desc: 'Inflate tires \nto correct pressure.',
        longDesc: ''
    },
    3328: {
        desc: 'Cont. driving possible: \nInflate tires.',
        longDesc:
            "Inflate tires: \nYou can continue driving at a maximum speed of 80 mph. \nTire pressure too low. Check tire pressure \non all tires and inflate tires at the next \nopportunity. \nAfterwards, reset Tire Pressure Monitor \n(TPM). \nSee Owner's Manual \nfor more information."
    },
    3329: {
        desc: 'Cont. driving possible: \nCross traffic alert.',
        longDesc: ''
    },
    3330: {
        desc: 'Cont. driving possible: \nCross traffic alert.',
        longDesc: ''
    },
    3331: {
        desc: 'Battery not \ncharging.',
        longDesc:
            'Battery not charging: \nYou can continue driving. \nLimited driving time remaining. \nEnergy supply fault. \nContinue driving to nearest service center to avoid vehicle problems.'
    },
    3332: {
        desc: 'Check engine oil \nlevel.',
        longDesc: 'Check engine oil level: \nOil level has not been determined for some time. \nPlease measure engine oil level.'
    },
    3333: {
        desc: 'Cont. driving possible: \nSteering.',
        longDesc: ''
    },
    3334: {
        desc: 'Cont. driving possible: \nCross traffic alert.',
        longDesc: ''
    },
    3335: {
        desc: 'Cruise Control \nactivated.',
        longDesc: ''
    },
    3336: {
        desc: 'Cruise Control. \nAdjustment %0',
        longDesc: ''
    },
    3337: {
        desc: 'Speed limiter \nactivated.',
        longDesc: ''
    },
    3338: {
        desc: 'Speed limiter. \nAdjustment %0',
        longDesc: ''
    },
    3339: {
        desc: 'Function not available \nin SPORT.',
        longDesc: ''
    },
    3340: {
        desc: '',
        longDesc:
            "Water injection: \nTop up water tank with distilled water at your convenience. \nWater injection is deactivated when tank is empty. \nSee Owner's Manual for more information."
    },
    3341: {
        desc: 'Stop carefully: \nFire risk.',
        longDesc:
            'Fire risk: \nstop carefully and get out of the \nvehicle. \nHigh voltage battery damaged. \nBeware of any traffic. \nMake an emergency call.'
    },
    3342: {
        desc: 'Rear window heating \nis permanently on.',
        longDesc: ''
    },
    3343: {
        desc: '',
        longDesc: ''
    },
    3344: {
        desc: '',
        longDesc: ''
    },
    3345: {
        desc: '',
        longDesc: ''
    },
    3346: {
        desc: '',
        longDesc: ''
    },
    3347: {
        desc: 'Check direction of \ntravel.',
        longDesc: ''
    },
    3348: {
        desc: 'Side protection.',
        longDesc: ''
    },
    3349: {
        desc: 'Inductive charging \nnot possible.',
        longDesc: ''
    },
    3351: {
        desc: '',
        longDesc: ''
    },
    3352: {
        desc: 'Stop carefully. \nSteering wheel lock.',
        longDesc: ''
    },
    3353: {
        desc: 'Increase LIMIT \n%0',
        longDesc: ''
    },
    3354: {
        desc: 'Reduce LIMIT \n%0',
        longDesc: ''
    },
    3355: {
        desc: 'Increase \nspeed %0',
        longDesc: ''
    },
    3356: {
        desc: 'Reduce \nspeed %0',
        longDesc: ''
    },
    3357: {
        desc: 'Damage to vehicle \ndetected.',
        longDesc: ''
    },
    3358: {
        desc: 'Diagnostic mode active.',
        longDesc: ''
    },
    3359: {
        desc: 'Fuel tank gauge. \nCont. driving possible.',
        longDesc: ''
    },
    3360: {
        desc: '',
        longDesc: ''
    },
    3361: {
        desc: 'Electric drive.',
        longDesc: ''
    },
    3362: {
        desc: 'n. y. t.',
        longDesc: ''
    },
    3363: {
        desc: 'n. y. t.',
        longDesc: ''
    },
    3364: {
        desc: 'n. y. t.',
        longDesc: ''
    },
    3365: {
        desc: 'Give way warning.',
        longDesc: ''
    },
    3366: {
        desc: 'Give way warning.',
        longDesc: ''
    },
    3367: {
        desc: 'Give way warning.',
        longDesc: ''
    },
    3368: {
        desc: '',
        longDesc: ''
    },
    3369: {
        desc: 'Not available.',
        longDesc: ''
    },
    3370: {
        desc: '{0}_{1}_{2}_KW{3,date,ww}_{3,date,yyMMdd}_{3,time,HHmm}',
        longDesc: ''
    },
    4372: {
        desc: 'Side collision warning.',
        longDesc: ''
    },
    4373: {
        desc: 'Lane departure \nwarning.',
        longDesc: ''
    },
    4374: {
        desc: 'Active Blind Spot \nDetection.',
        longDesc: ''
    },
    4376: {
        desc: '',
        longDesc: ''
    },
    4377: {
        desc: 'Oil at minimum. \nPlease refill.',
        longDesc: ''
    },
    4378: {
        desc: 'Oil below minimum. \nRefill immediately.',
        longDesc: ''
    },
    4379: {
        desc: 'Not possible to \nchange gear position.',
        longDesc: ''
    },
    4380: {
        desc: 'Preparing for \nrefueling…',
        longDesc: ''
    },
    4381: {
        desc: 'Engine start delayed.',
        longDesc: ''
    },
    4382: {
        desc: 'Steering Assistant \ndeactivated.',
        longDesc: ''
    },
    4383: {
        desc: 'Rear seat back \nleft unlocked.',
        longDesc: ''
    },
    4384: {
        desc: 'Rear seat back \nright unlocked.',
        longDesc: ''
    },
    4385: {
        desc: '',
        longDesc: ''
    },
    4386: {
        desc: 'n. y. t.',
        longDesc: ''
    },
    4387: {
        desc: 'n. y. t.',
        longDesc: ''
    },
    4388: {
        desc: 'Low vehicle level.',
        longDesc: ''
    },
    4389: {
        desc: '',
        longDesc: ''
    },
    4390: {
        desc: '',
        longDesc: ''
    },
    4391: {
        desc: 'Emergency braking.',
        longDesc: ''
    },
    4392: {
        desc: 'Emergency Stop \nAssistant limited.',
        longDesc: ''
    },
    4393: {
        desc: 'Emergency Stop \nAssistant limited.',
        longDesc: ''
    },
    4394: {
        desc: 'Emergency Stop \nAssistant limited.',
        longDesc: ''
    },
    4395: {
        desc: 'Emergency Stop \nAssistant malfunction.',
        longDesc: ''
    },
    4396: {
        desc: 'Reversing Assistant: \nDrive vehicle yourself.',
        longDesc: ''
    },
    4397: {
        desc: 'Reversing Assistant: \nDrive vehicle yourself.',
        longDesc: ''
    },
    4398: {
        desc: 'n. y. t.',
        longDesc: ''
    },
    4399: {
        desc: 'n. y. t.',
        longDesc: ''
    },
    4400: {
        desc: 'n. y. t.',
        longDesc: ''
    },
    4401: {
        desc: 'n. y. t.',
        longDesc: ''
    },
    4402: {
        desc: 'n. y. t.',
        longDesc: ''
    },
    4403: {
        desc: '',
        longDesc: ''
    },
    4404: {
        desc: '',
        longDesc: ''
    },
    4405: {
        desc: 'Trailer Assistant: \nDrive vehicle yourself.',
        longDesc: ''
    },
    4406: {
        desc: 'Trailer Assistant: \nDrive vehicle yourself.',
        longDesc: ''
    },
    4407: {
        desc: 'To open tailgate: \nPress twice.',
        longDesc: ''
    },
    4408: {
        desc: 'To open tailgate: \nShift into Park/unlock.',
        longDesc: ''
    },
    4409: {
        desc: 'Towing a trailer.',
        longDesc: ''
    },
    4410: {
        desc: 'Fuel level: \nDrive power adjusted.',
        longDesc: ''
    },
    4411: {
        desc: 'NFC code missing.',
        longDesc: ''
    },
    4412: {
        desc: 'NFC code missing: \nOperation not poss.',
        longDesc: ''
    },
    4413: {
        desc: 'NFC code recognized.',
        longDesc: ''
    },
    4414: {
        desc: 'n. y. t.',
        longDesc: ''
    },
    4416: {
        desc: 'n. y. t.',
        longDesc: ''
    },
    4417: {
        desc: 'n. y. t.',
        longDesc: ''
    }
};
